import type { RawAccounts, Wallet } from './types';
import type { Meta } from '@rango-dev/wallets-shared';

import { Networks, WalletTypes } from '@rango-dev/wallets-shared';

const evmAddress = '0x2702d89c1c8658b49c45dd460deebcc45faec03c';
const cosmosAddress = 'cosmos1unf2rcytjxfpz8x8ar63h4qeftadptg5r5qswd';

export const sampleRawAccounts: RawAccounts = (() => {
  const evm = [
    'BSC',
    'POLYGON',
    'ETH',
    'AVAX_CCHAIN',
    'ARBITRUM',
    'FANTOM',
    'OPTIMISM',
    'OKC',
    'CRONOS',
    'MOONRIVER',
    'MOONBEAM',
    'HECO',
    'AURORA',
    'HARMONY',
    'EVMOS',
    'GNOSIS',
    'FUSE',
    'BOBA',
  ].map((network) => {
    return {
      name: network,
      accounts: [
        {
          address: evmAddress,
          walletType: WalletTypes.META_MASK,
        },
      ],
    };
  });
  const cosmos = [
    {
      name: Networks.COSMOS,
      accounts: [
        {
          address: cosmosAddress,
          walletType: WalletTypes.KEPLR,
        },
      ],
    },
  ];
  return {
    blockchains: [...evm, ...cosmos],
  };
})();

export const metamaskWallet = {
  blockchains: [
    {
      name: 'BSC',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'BSC',
              symbol: 'SWAP8.IO',
              ticker: 'SWAP8.IO',
              address: '0xcaee79616cffeb53fdda5792742a5c084f879dec',
              rawAmount: '980000000000000000000000',
              decimal: 18,
              amount: '980000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'PDOT.IO',
              ticker: 'PDOT.IO',
              address: '0x8bd0e87273364ebbe3482efc166f7e0d34d82c25',
              rawAmount: '95641000000000000000000',
              decimal: 18,
              amount: '95641',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ZEPE.IO',
              ticker: 'ZEPE.IO',
              address: '0x119e2ad8f0c85c6f61afdf0df69693028cdc10be',
              rawAmount: '750000000000000000000000',
              decimal: 18,
              amount: '750000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: '0GAS.IO',
              ticker: '0GAS.IO',
              address: '0x2231e1c01056aebab3113d684b034b50a99a56c7',
              rawAmount: '16000000000000',
              decimal: 9,
              amount: '16000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'LUNA',
              ticker: 'LUNA',
              address: '0x030612e22610219733f3e942bb67004d6cbd796b',
              rawAmount: '350000000000000000000',
              decimal: 18,
              amount: '350',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'FTM',
              ticker: 'FTM',
              address: '0xad29abb318791d579433d831ed122afeaf29dcfe',
              rawAmount: '60035619283908361569',
              decimal: 18,
              amount: '60.035619283908361569',
              logo: 'https://api.rango.exchange/i/mZqhCJ',
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'GGBOXS.COM',
              ticker: 'GGBOXS.COM',
              address: '0x2248ba304d2045cdc144866ce37d1435a30b29f3',
              rawAmount: '60000000000000000000000',
              decimal: 18,
              amount: '60000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'AGP',
              ticker: 'AGP',
              address: '0x1c749d5f5630cf365673bf6c0b6b0570c48da112',
              rawAmount: '6300000',
              decimal: 6,
              amount: '6.3',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'UST',
              ticker: 'UST',
              address: '0x3d4350cd54aef9f9b2c29435e0fa809957b3f30a',
              rawAmount: '5015300',
              decimal: 6,
              amount: '5.0153',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ALPACA',
              ticker: 'ALPACA',
              address: '0xb926beb62d7a680406e06327c87307c1ffc4ab09',
              rawAmount: '50',
              decimal: 18,
              amount: '0.00000000000000005',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'NUSD',
              ticker: 'NUSD',
              address: '0x23b891e5c62e0955ae2bd185990103928ab817b3',
              rawAmount: '25863658894004353627',
              decimal: 18,
              amount: '25.863658894004353627',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'RENUSDT',
              ticker: 'RENUSDT',
              address: '0xf55941e971302c634c586416c43469f3ead5ad3e',
              rawAmount: '4997500',
              decimal: 6,
              amount: '4.9975',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MMDEX.IO',
              ticker: 'MMDEX.IO',
              address: '0xdc4cb4c3587532409a4545aa79a15d967bed1c08',
              rawAmount: '250000000000000000000000',
              decimal: 18,
              amount: '250000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BOWDAO.NET',
              ticker: 'BOWDAO.NET',
              address: '0x3bab61ad5d103bb5b203c9092eb3a5e11677a5d0',
              rawAmount: '660000000000000000000000',
              decimal: 18,
              amount: '660000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'APC',
              ticker: 'APC',
              address: '0xda2d21872999e700a715a1bda3153eb9079770bb',
              rawAmount: '124889000',
              decimal: 6,
              amount: '124.889',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'LINK',
              ticker: 'LINK',
              address: '0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd',
              rawAmount: '7095490344',
              decimal: 18,
              amount: '0.000000007095490344',
              logo: 'https://api.rango.exchange/i/hWjRK2',
              usdPrice: 5.947,
            },
            {
              chain: 'BSC',
              symbol: 'LUNA2.APP',
              ticker: 'LUNA2.APP',
              address: '0x9171c79f543b298fbd39642dc29e1454e2878665',
              rawAmount: '188888',
              decimal: 0,
              amount: '188888',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'EOS',
              ticker: 'EOS',
              address: '0x56b6fb708fc5732dec1afc8d8556423a2edccbd6',
              rawAmount: '6521653134',
              decimal: 18,
              amount: '0.000000006521653134',
              logo: 'https://api.rango.exchange/i/KeunI3',
              usdPrice: 0.874,
            },
            {
              chain: 'BSC',
              symbol: 'ANGELDUST',
              ticker: 'ANGELDUST',
              address: '0x32d3499feca3f881d779f0183d7b41d32b2498df',
              rawAmount: '741825180000',
              decimal: 6,
              amount: '741825.18',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ORBIT',
              ticker: 'ORBIT',
              address: '0xdfb8603d947ab42fb76eb3bb14d9dde4334130d2',
              rawAmount: '58397000000000000000000',
              decimal: 18,
              amount: '58397',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'WAVAX',
              ticker: 'WAVAX',
              address: '0x96412902aa9aff61e13f085e70d3152c6ef2a817',
              rawAmount: '8087494716',
              decimal: 18,
              amount: '0.000000008087494716',
              logo: 'https://api.rango.exchange/i/7QDOTz',
              usdPrice: 11.745,
            },
            {
              chain: 'BSC',
              symbol: 'GASDAO.CC',
              ticker: 'GASDAO.CC',
              address: '0x1c0294b8a8ae3d64d8629de723cb9e44f5f12c63',
              rawAmount: '9500000000000',
              decimal: 8,
              amount: '95000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MINIDOGE',
              ticker: 'MINIDOGE',
              address: '0x50fa1d465b2a4a13d64e9fa428ccc98ec873ae64',
              rawAmount: '500000000000000000000000000000',
              decimal: 18,
              amount: '500000000000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'VELO',
              ticker: 'VELO',
              address: '0x17d1285bc68d9085f8e4b86fc565e452b29dc48f',
              rawAmount: '150000000000000000000000',
              decimal: 18,
              amount: '150000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ARTQ.ME',
              ticker: 'ARTQ.ME',
              address: '0xf0ef30735455d5315873cc2e2966cb20047bdb29',
              rawAmount: '6000000000000000000000',
              decimal: 18,
              amount: '6000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'USDCSWAP.ORG',
              ticker: 'USDCSWAP.ORG',
              address: '0x43217359af5f01cf82c12a7a058ba221acdaef38',
              rawAmount: '500',
              decimal: 0,
              amount: '500',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: '1INCH',
              ticker: '1INCH',
              address: '0x111111111117dc0aa78b770fa6a738034120c302',
              rawAmount: '271002710027100234',
              decimal: 18,
              amount: '0.271002710027100234',
              logo: 'https://api.rango.exchange/i/9D6oXE',
              usdPrice: 0.397,
            },
            {
              chain: 'BSC',
              symbol: 'MAI',
              ticker: 'MAI',
              address: '0x3f56e0c36d275367b8c502090edf38289b3dea0d',
              rawAmount: '19277503723092914708',
              decimal: 18,
              amount: '19.277503723092914708',
              logo: 'https://api.rango.exchange/i/rcaHva',
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ATOM',
              ticker: 'ATOM',
              address: '0x0eb3a705fc54725037cc9e008bdede697f62f335',
              rawAmount: '28750711363627413',
              decimal: 18,
              amount: '0.028750711363627413',
              logo: 'https://api.rango.exchange/i/UT9ERo',
              usdPrice: 8.94,
            },
            {
              chain: 'BSC',
              symbol: '1GAS.ORG',
              ticker: '1GAS.ORG',
              address: '0xd35f9ab96d04adb02fd549ef6a576ce4e2c1d935',
              rawAmount: '92280000000000000000000',
              decimal: 18,
              amount: '92280',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BOHM',
              ticker: 'BOHM',
              address: '0xbe2bac22b5f4d1126c705cb21335960531bae847',
              rawAmount: '100000000000000000000',
              decimal: 18,
              amount: '100',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BTCB',
              ticker: 'BTCB',
              address: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
              rawAmount: '71529099712895',
              decimal: 18,
              amount: '0.000071529099712895',
              logo: 'https://api.rango.exchange/i/MHEGHG',
              usdPrice: 16863.776,
            },
            {
              chain: 'BSC',
              symbol: 'EDG',
              ticker: 'EDG',
              address: '0xa2e26f5f663e18fa942db6edf3269449d75d6d85',
              rawAmount: '10000000000',
              decimal: 25,
              amount: '0.000000000000001',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'SUSHI',
              ticker: 'SUSHI',
              address: '0x947950bcc74888a40ffa2593c5798f11fc9124c4',
              rawAmount: '836519539228464427',
              decimal: 18,
              amount: '0.836519539228464427',
              logo: 'https://api.rango.exchange/i/NgIT7y',
              usdPrice: 0.941,
            },
            {
              chain: 'BSC',
              symbol: 'PGAME',
              ticker: 'PGAME',
              address: '0x4dc90e30015af10e64a2f1ac390754cfb0454373',
              rawAmount: '10952400',
              decimal: 6,
              amount: '10.9524',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MATIC',
              ticker: 'MATIC',
              address: '0xcc42724c6683b7e57334c4e856f4c9965ed682bd',
              rawAmount: '1000000008755996216',
              decimal: 18,
              amount: '1.000000008755996216',
              logo: 'https://api.rango.exchange/i/vTlTjv',
              usdPrice: 0.791,
            },
            {
              chain: 'BSC',
              symbol: 'FISTDAO',
              ticker: 'FISTDAO',
              address: '0x41791dab02a1f9b2430cd46f2c6a2b33aa7fd25d',
              rawAmount: '880000000000',
              decimal: 9,
              amount: '880',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'FF18.IO',
              ticker: 'FF18.IO',
              address: '0x491b25000d386cd31307580171a510d32d7e64ee',
              rawAmount: '800000000000000000000000',
              decimal: 18,
              amount: '800000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'RAY',
              ticker: 'RAY',
              address: '0x13b6a55662f6591f8b8408af1c73b017e32eedb8',
              rawAmount: '4793579',
              decimal: 6,
              amount: '4.793579',
              logo: 'https://api.rango.exchange/i/kNjVdm',
              usdPrice: 0.15,
            },
            {
              chain: 'BSC',
              symbol: 'AGEUR',
              ticker: 'AGEUR',
              address: '0x38c84d5bbad726d465cf6a5349e41d6d7095faf7',
              rawAmount: '8242220000000000',
              decimal: 18,
              amount: '0.00824222',
              logo: 'https://api.rango.exchange/i/d5IrO0',
              usdPrice: 1.059,
            },
            {
              chain: 'BSC',
              symbol: 'KK',
              ticker: 'KK',
              address: '0x482794a6efb37e3fbd51f537c7102e9ab188b818',
              rawAmount: '53000000000000000000',
              decimal: 18,
              amount: '53',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'O3',
              ticker: 'O3',
              address: '0xee9801669c6138e84bd50deb500827b776777d28',
              rawAmount: '1256000000000000000',
              decimal: 18,
              amount: '1.256',
              logo: 'https://api.rango.exchange/i/lfPJOy',
              usdPrice: 0.0443,
            },
            {
              chain: 'BSC',
              symbol: 'AIR',
              ticker: 'AIR',
              address: '0xbc6675de91e3da8eac51293ecb87c359019621cf',
              rawAmount: '1921604000000000000000000',
              decimal: 18,
              amount: '1921604',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'DOGGY',
              ticker: 'DOGGY',
              address: '0x74926b3d118a63f6958922d3dc05eb9c6e6e00c6',
              rawAmount: '283511485676805491',
              decimal: 18,
              amount: '0.283511485676805491',
              logo: 'https://api.rango.exchange/i/1lJ2Z3',
              usdPrice: 0.00031,
            },
            {
              chain: 'BSC',
              symbol: 'SEG',
              ticker: 'SEG',
              address: '0x2eeff21c71ae38f9c34496cd9250c0d186dcd988',
              rawAmount: '100000000000000',
              decimal: 18,
              amount: '0.0001',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MIM',
              ticker: 'MIM',
              address: '0xfe19f0b51438fd612f6fd59c1dbb3ea319f433ba',
              rawAmount: '15022048536804216097',
              decimal: 18,
              amount: '15.022048536804216097',
              logo: 'https://api.rango.exchange/i/L5wafC',
              usdPrice: 0.993,
            },
            {
              chain: 'BSC',
              symbol: 'USDSWAP.IO',
              ticker: 'USDSWAP.IO',
              address: '0xb2ad5142b8ccb380731866bc42b3619759f3f7b3',
              rawAmount: '1286698',
              decimal: 0,
              amount: '1286698',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'PSG',
              ticker: 'PSG',
              address: '0xbc5609612b7c44bef426de600b5fd1379db2ecf1',
              rawAmount: '14',
              decimal: 2,
              amount: '0.14',
              logo: 'https://api.rango.exchange/i/OiA2jQ',
              usdPrice: 5.685,
            },
            {
              chain: 'BSC',
              symbol: 'ETH',
              ticker: 'ETH',
              address: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
              rawAmount: '14825954098793468',
              decimal: 18,
              amount: '0.014825954098793468',
              logo: 'https://api.rango.exchange/i/qr4L6S',
              usdPrice: 1209.693,
            },
            {
              chain: 'BSC',
              symbol: 'SAFEMOON',
              ticker: 'SAFEMOON',
              address: '0x2df0b14ee90671021b016dab59f2300fb08681fa',
              rawAmount: '255',
              decimal: 18,
              amount: '0.000000000000000255',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'POODL',
              ticker: 'POODL',
              address: '0x4a68c250486a116dc8d6a0c5b0677de07cc09c5d',
              rawAmount: '6184580930',
              decimal: 9,
              amount: '6.18458093',
              logo: 'https://api.rango.exchange/i/ehIL4M',
              usdPrice: 7.1e-9,
            },
            {
              chain: 'BSC',
              symbol: 'AVAX',
              ticker: 'AVAX',
              address: '0x1ce0c2827e2ef14d5c4f29a091d735a204794041',
              rawAmount: '4705457968658479',
              decimal: 18,
              amount: '0.004705457968658479',
              logo: 'https://api.rango.exchange/i/kX4edQ',
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MGRT',
              ticker: 'MGRT',
              address: '0xd08f7b01fdd26928dcdc956610a5332f17b3ea11',
              rawAmount: '1119800000000000000',
              decimal: 18,
              amount: '1.1198',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'WBNB',
              ticker: 'WBNB',
              address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
              rawAmount: '23374035802351054',
              decimal: 18,
              amount: '0.023374035802351054',
              logo: 'https://api.rango.exchange/i/lRTcZT',
              usdPrice: 248.431,
            },
            {
              chain: 'BSC',
              symbol: 'ANYFUSE',
              ticker: 'ANYFUSE',
              address: '0x43242138833e8d360e84920462a483eb9e35c8b4',
              rawAmount: '32000000000000000000',
              decimal: 18,
              amount: '32',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'AGILESWAP.IO',
              ticker: 'AGILESWAP.IO',
              address: '0xcf8b4e69707e22dc5062f80576d9f069275ed1b5',
              rawAmount: '12000000000000',
              decimal: 9,
              amount: '12000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BNBM',
              ticker: 'BNBM',
              address: '0xe8d6eccf4df7067a52d43495c11b69deeedb965e',
              rawAmount: '207961000000000000000000',
              decimal: 18,
              amount: '207961',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'PAYOU',
              ticker: 'PAYOU',
              address: '0x1e8f7bfdcf6d95eea81e039234624fa6b78bd389',
              rawAmount: '923000000000000000000',
              decimal: 18,
              amount: '923',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'AABEK',
              ticker: 'AABEK',
              address: '0x68d1569d1a6968f194b4d93f8d0b416c123a599f',
              rawAmount: '20819314000000000',
              decimal: 9,
              amount: '20819314',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'TRX',
              ticker: 'TRX',
              address: '0x85eac5ac2f758618dfa09bdbe0cf174e7d574d5b',
              rawAmount: '2425322528',
              decimal: 18,
              amount: '0.000000002425322528',
              logo: 'https://api.rango.exchange/i/sJnSkq',
              usdPrice: 0.055,
            },
            {
              chain: 'BSC',
              symbol: 'RIFTDAO.NET',
              ticker: 'RIFTDAO.NET',
              address: '0x4f6a82bb5fd0996158c9ac6bd3605489cad82d8d',
              rawAmount: '738097000000000000000000',
              decimal: 18,
              amount: '738097',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ETH-1INCH.IO',
              ticker: 'ETH-1INCH.IO',
              address: '0xa83b6a470771da2d979480b2e742962088608ced',
              rawAmount: '870000000000000000',
              decimal: 18,
              amount: '0.87',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ODDZ',
              ticker: 'ODDZ',
              address: '0xcd40f2670cf58720b694968698a5514e924f742d',
              rawAmount: '77970995683712403',
              decimal: 18,
              amount: '0.077970995683712403',
              logo: 'https://api.rango.exchange/i/s6bU0A',
              usdPrice: 0.0121,
            },
            {
              chain: 'BSC',
              symbol: 'TBBT.ORG',
              ticker: 'TBBT.ORG',
              address: '0xbf7183b8c8e5bb2d10f63678abb5d52df72712b2',
              rawAmount: '50000000000000000000000',
              decimal: 18,
              amount: '50000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'DASH',
              ticker: 'DASH',
              address: '0x3291a9352e553740bf78ce94fad611924b640d0f',
              rawAmount: '100000000000000000000',
              decimal: 18,
              amount: '100',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BAKE',
              ticker: 'BAKE',
              address: '0xe02df9e3e622debdd69fb838bb799e3f168902c5',
              rawAmount: '2896167082922666',
              decimal: 18,
              amount: '0.002896167082922666',
              logo: 'https://api.rango.exchange/i/dQuv0N',
              usdPrice: 0.141,
            },
            {
              chain: 'BSC',
              symbol: 'USDC',
              ticker: 'USDC',
              address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
              rawAmount: '15641472731959171181',
              decimal: 18,
              amount: '15.641472731959171181',
              logo: 'https://api.rango.exchange/i/toXKGV',
              usdPrice: 1.005,
            },
            {
              chain: 'BSC',
              symbol: 'LTC',
              ticker: 'LTC',
              address: '0x4338665cbb7b2485a8855a139b75d5e34ab0db94',
              rawAmount: '6918750157',
              decimal: 18,
              amount: '0.000000006918750157',
              logo: 'https://api.rango.exchange/i/Rw2jCX',
              usdPrice: 65.204,
            },
            {
              chain: 'BSC',
              symbol: 'NEAR',
              ticker: 'NEAR',
              address: '0x1fa4a73a3f0133f0025378af00236f3abdee5d63',
              rawAmount: '508963275751495577',
              decimal: 18,
              amount: '0.508963275751495577',
              logo: 'https://api.rango.exchange/i/kL2qwj',
              usdPrice: 1.298,
            },
            {
              chain: 'BSC',
              symbol: 'BTG',
              ticker: 'BTG',
              address: '0x1385e68e3b5ea66fc50a221f8dcbabbfd3ee282b',
              rawAmount: '11000000000',
              decimal: 6,
              amount: '11000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'YTS',
              ticker: 'YTS',
              address: '0x3b4deb27a46e746776a661ecf523c42ed0400d54',
              rawAmount: '9000000000000000000000000',
              decimal: 18,
              amount: '9000000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'FLOKI',
              ticker: 'FLOKI',
              address: '0x2b3f34e9d4b127797ce6244ea341a83733ddd6e4',
              rawAmount: '62088935293887',
              decimal: 9,
              amount: '62088.935293887',
              logo: 'https://api.rango.exchange/i/UhBFxd',
              usdPrice: 1.89e-7,
            },
            {
              chain: 'BSC',
              symbol: 'SXP',
              ticker: 'SXP',
              address: '0x47bead2563dcbf3bf2c9407fea4dc236faba485a',
              rawAmount: '7193114712',
              decimal: 18,
              amount: '0.000000007193114712',
              logo: 'https://api.rango.exchange/i/3njEos',
              usdPrice: 0.207,
            },
            {
              chain: 'BSC',
              symbol: 'COSMICMINE',
              ticker: 'COSMICMINE',
              address: '0xde1e01b3ab6aa67909e41330067be7a46ec16c38',
              rawAmount: '300000000000000000',
              decimal: 18,
              amount: '0.3',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'SPACEPI',
              ticker: 'SPACEPI',
              address: '0x69b14e8d3cebfdd8196bfe530954a0c226e5008e',
              rawAmount: '5500000000000000',
              decimal: 9,
              amount: '5500000',
              logo: 'https://api.rango.exchange/i/01weSc',
              usdPrice: 1.02e-9,
            },
            {
              chain: 'BSC',
              symbol: 'ALPACA',
              ticker: 'ALPACA',
              address: '0x373233a38ae21cf0c4f9de11570e7d5aa6824a1e',
              rawAmount: '28102000000000000000000000',
              decimal: 18,
              amount: '28102000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MNEB',
              ticker: 'MNEB',
              address: '0xd22202d23fe7de9e3dbe11a2a88f42f4cb9507cf',
              rawAmount: '15000000000000',
              decimal: 8,
              amount: '150000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'DAO',
              ticker: 'DAO',
              address: '0x037b202ca88d2028d82936d5615ee5088cb9fd78',
              rawAmount: '9970000000000000',
              decimal: 18,
              amount: '0.00997',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BRISE',
              ticker: 'BRISE',
              address: '0x8fff93e810a2edaafc326edee51071da9d398e83',
              rawAmount: '10',
              decimal: 9,
              amount: '0.00000001',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: '3WORLDS.IO',
              ticker: '3WORLDS.IO',
              address: '0xc3238c3b7b8e32588a49c751aed808368e85122d',
              rawAmount: '12000000000000',
              decimal: 9,
              amount: '12000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ARKR.ORG',
              ticker: 'ARKR.ORG',
              address: '0x04645027122c9f152011f128c7085449b27cb6d7',
              rawAmount: '800000000000000000000000',
              decimal: 18,
              amount: '800000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'WADAX',
              ticker: 'WADAX',
              address: '0x35122d1fe8001296f61290b8ba42ef597af31fb7',
              rawAmount: '1000000000000',
              decimal: 6,
              amount: '1000000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BNBW',
              ticker: 'BNBW',
              address: '0x5558447b06867ffebd87dd63426d61c868c45904',
              rawAmount: '23752199000000000',
              decimal: 9,
              amount: '23752199',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'QI',
              ticker: 'QI',
              address: '0x8729438eb15e2c8b576fcc6aecda6a148776c0f5',
              rawAmount: '208452535759624275628',
              decimal: 18,
              amount: '208.452535759624275628',
              logo: 'https://api.rango.exchange/i/PwbKO2',
              usdPrice: 0.00664,
            },
            {
              chain: 'BSC',
              symbol: 'CAKE',
              ticker: 'CAKE',
              address: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
              rawAmount: '132130918185825847',
              decimal: 18,
              amount: '0.132130918185825847',
              logo: 'https://api.rango.exchange/i/UA0myt',
              usdPrice: 3.433,
            },
            {
              chain: 'BSC',
              symbol: 'LINKP.IO',
              ticker: 'LINKP.IO',
              address: '0xd5e3bf9045cfb1e6ded4b35d1b9c34be16d6eec3',
              rawAmount: '800000000000000000000000',
              decimal: 18,
              amount: '800000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BSCTOKEN',
              ticker: 'BSCTOKEN',
              address: '0x569b2cf0b745ef7fad04e8ae226251814b3395f9',
              rawAmount: '23752199000000000',
              decimal: 9,
              amount: '23752199',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'VERSE',
              ticker: 'VERSE',
              address: '0xbb92b9d18db99c3695bc820bf2c876d4b1527fa5',
              rawAmount: '3000000000000000',
              decimal: 9,
              amount: '3000000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'VERA',
              ticker: 'VERA',
              address: '0x0df62d2cd80591798721ddc93001afe868c367ff',
              rawAmount: '800000000000000000000000',
              decimal: 18,
              amount: '800000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'SQUIDV2',
              ticker: 'SQUIDV2',
              address: '0xd85842708252c7752f9e503f90561068433d0044',
              rawAmount: '1000000000000000000',
              decimal: 18,
              amount: '1',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'WETH',
              ticker: 'WETH',
              address: '0x4db5a66e937a9f4473fa95b1caf1d1e1d62e29ea',
              rawAmount: '9430724572',
              decimal: 18,
              amount: '0.000000009430724572',
              logo: 'https://api.rango.exchange/i/wNnplE',
              usdPrice: 1396.147,
            },
            {
              chain: 'BSC',
              symbol: 'ATOM',
              ticker: 'ATOM',
              address: '0x725e02c7f9168f45b3699cfb7c262fb6dd355e84',
              rawAmount: '99561480',
              decimal: 6,
              amount: '99.56148',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'FLOKI',
              ticker: 'FLOKI',
              address: '0xfb5b838b6cfeedc2873ab27866079ac55363d37e',
              rawAmount: '62088935293887',
              decimal: 9,
              amount: '62088.935293887',
              logo: 'https://api.rango.exchange/i/fIrbfa',
              usdPrice: 0.00000913,
            },
            {
              chain: 'BSC',
              symbol: 'AZSWAP.IO',
              ticker: 'AZSWAP.IO',
              address: '0xfd4c532a8c17bd326c2dc63b88d49306ce27f80b',
              rawAmount: '18000000000000',
              decimal: 9,
              amount: '18000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'TU7.ORG',
              ticker: 'TU7.ORG',
              address: '0x442b656f5a5c3dd09790951810c5a15ea5295b51',
              rawAmount: '7127850000000000',
              decimal: 9,
              amount: '7127850',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'FLUX',
              ticker: 'FLUX',
              address: '0xb16600c510b0f323dee2cb212924d90e58864421',
              rawAmount: '950000000000000000000000',
              decimal: 18,
              amount: '950000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'XRP',
              ticker: 'XRP',
              address: '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe',
              rawAmount: '5688021754',
              decimal: 18,
              amount: '0.000000005688021754',
              logo: 'https://api.rango.exchange/i/zTYnq2',
              usdPrice: 0.34,
            },
            {
              chain: 'BSC',
              symbol: 'BITTT.IO',
              ticker: 'BITTT.IO',
              address: '0x9603a3d3dcccf5ef1a2060a3da796ac084cc66eb',
              rawAmount: '268551000000000000000000',
              decimal: 18,
              amount: '268551',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'AXLUSDC',
              ticker: 'AXLUSDC',
              address: '0x4268b8f0b87b6eae5d897996e6b845ddbd99adf3',
              rawAmount: '5978049',
              decimal: 6,
              amount: '5.978049',
              logo: 'https://api.rango.exchange/tokens/COSMOS/AXLUSDC.png',
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'SDJT',
              ticker: 'SDJT',
              address: '0xbb368656efa67361b0063fe0f11cb08bd460246d',
              rawAmount: '100000000',
              decimal: 9,
              amount: '0.1',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ONE',
              ticker: 'ONE',
              address: '0x03ff0ff224f904be3118461335064bb48df47938',
              rawAmount: '4789152388',
              decimal: 18,
              amount: '0.000000004789152388',
              logo: 'https://api.rango.exchange/i/5MOMsg',
              usdPrice: 0.0115,
            },
            {
              chain: 'BSC',
              symbol: 'STI',
              ticker: 'STI',
              address: '0x4f5f7a7dca8ba0a7983381d23dfc5eaf4be9c79a',
              rawAmount: '1000',
              decimal: 10,
              amount: '0.0000001',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'APE',
              ticker: 'APE',
              address: '0xa1b99485d58d70d86e455ab8823492090c3f43c0',
              rawAmount: '350000000000000000000',
              decimal: 18,
              amount: '350',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'COOK',
              ticker: 'COOK',
              address: '0x965b0df5bda0e7a0649324d78f03d5f7f2de086a',
              rawAmount: '35733206194802111275189',
              decimal: 18,
              amount: '35733.206194802111275189',
              logo: 'https://api.rango.exchange/i/owq1WS',
              usdPrice: 0.000247,
            },
            {
              chain: 'BSC',
              symbol: 'FUSE',
              ticker: 'FUSE',
              address: '0x5857c96dae9cf8511b08cb07f85753c472d36ea3',
              rawAmount: '102000000000000000000',
              decimal: 18,
              amount: '102',
              logo: 'https://api.rango.exchange/i/3hWqus',
              usdPrice: 0.0603,
            },
            {
              chain: 'BSC',
              symbol: 'CGB',
              ticker: 'CGB',
              address: '0x7e6202903275772044198d07b8a536cc064f8480',
              rawAmount: '211000000',
              decimal: 6,
              amount: '211',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'DEF8.IO',
              ticker: 'DEF8.IO',
              address: '0x556798dd55db12562a6950ea8339a273539b0495',
              rawAmount: '82445000000000000000000',
              decimal: 18,
              amount: '82445',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'WMATIC',
              ticker: 'WMATIC',
              address: '0xc836d8dc361e44dbe64c4862d55ba041f88ddd39',
              rawAmount: '1887651939',
              decimal: 18,
              amount: '0.000000001887651939',
              logo: 'https://api.rango.exchange/i/QpOgNr',
              usdPrice: 0.791,
            },
            {
              chain: 'BSC',
              symbol: 'BSTAKE.NET',
              ticker: 'BSTAKE.NET',
              address: '0x1f040f15ab15b7e0dfac935873fadbe43d015535',
              rawAmount: '480000000000000000000000',
              decimal: 18,
              amount: '480000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'XCH5.IO',
              ticker: 'XCH5.IO',
              address: '0xb3ec4e17c1c0079d977354875ab924c088325306',
              rawAmount: '821112000000000',
              decimal: 9,
              amount: '821112',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'FS',
              ticker: 'FS',
              address: '0xe3a41e4dacc892ecaedfa009be5baa2d3ab4844d',
              rawAmount: '1003947318555099196',
              decimal: 18,
              amount: '1.003947318555099196',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BSC-COIN',
              ticker: 'BSC-COIN',
              address: '0xe3e1147acd39687a25ca7716227c604500f5c31a',
              rawAmount: '5000000000000',
              decimal: 6,
              amount: '5000000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'APEFESTPOAP.COM',
              ticker: 'APEFESTPOAP.COM',
              address: '0x57dac6482784a0f093483e6313804812fa177437',
              rawAmount: '5555000000000000000000',
              decimal: 18,
              amount: '5555',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'SAFEMOON-DIVIDEND.COM',
              ticker: 'SAFEMOON-DIVIDEND.COM',
              address: '0xdbe3e700ab26cbf3523d850b5d892fd17e0ce343',
              rawAmount: '31820000000000000000000',
              decimal: 18,
              amount: '31820',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'AXAX.IO',
              ticker: 'AXAX.IO',
              address: '0x58b5c4697dc70f3d889225260944cdd9c270c132',
              rawAmount: '77000000000000',
              decimal: 9,
              amount: '77000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'RRDAO.NET',
              ticker: 'RRDAO.NET',
              address: '0xa47b34ff31e22ef03f6054af19542bcde260cdc7',
              rawAmount: '738097000000000000000000',
              decimal: 18,
              amount: '738097',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ETP',
              ticker: 'ETP',
              address: '0x89679307c3d2e4e289da2ccd4d3c44ff39292189',
              rawAmount: '100000000000000',
              decimal: 18,
              amount: '0.0001',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'DOT',
              ticker: 'DOT',
              address: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
              rawAmount: '7180274458',
              decimal: 18,
              amount: '0.000000007180274458',
              logo: 'https://api.rango.exchange/i/suQRJx',
              usdPrice: 4.528,
            },
            {
              chain: 'BSC',
              symbol: 'AGMC.IO',
              ticker: 'AGMC.IO',
              address: '0xef27b9cb67aa93ec3494a60f1ea9380e86175b26',
              rawAmount: '800000000000000000000000',
              decimal: 18,
              amount: '800000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'RDRIP',
              ticker: 'RDRIP',
              address: '0xa02a0b2d67d4fa48677a79cadc483e114049916d',
              rawAmount: '40214587120000',
              decimal: 6,
              amount: '40214587.12',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BUSD',
              ticker: 'BUSD',
              address: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
              rawAmount: '2925825323281948117',
              decimal: 18,
              amount: '2.925825323281948117',
              logo: 'https://api.rango.exchange/i/tY13sD',
              usdPrice: 1.001,
            },
            {
              chain: 'BSC',
              symbol: 'MKS',
              ticker: 'MKS',
              address: '0x64f2c2aa04755507a2ecd22ceb8c475b7a750a3a',
              rawAmount: '6500000000000000000000000',
              decimal: 18,
              amount: '6500000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BITMARTEX.COM',
              ticker: 'BITMARTEX.COM',
              address: '0xdac0bb03158048b70abcfeb3be2607b625526f20',
              rawAmount: '400000000000000000000',
              decimal: 18,
              amount: '400',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'APT',
              ticker: 'APT',
              address: '0xec811fbcd12f67874891cdbbbc95d9f73db3fbb0',
              rawAmount: '40000000',
              decimal: 6,
              amount: '40',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MELLO',
              ticker: 'MELLO',
              address: '0x0198be93b7cae38da7e2fd966946412cc36447bf',
              rawAmount: '17777000000000000000000',
              decimal: 18,
              amount: '17777',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ICE',
              ticker: 'ICE',
              address: '0xf16e81dce15b08f326220742020379b855b87df9',
              rawAmount: '3071447531',
              decimal: 18,
              amount: '0.000000003071447531',
              logo: 'https://api.rango.exchange/i/my1npH',
              usdPrice: 0.121,
            },
            {
              chain: 'BSC',
              symbol: 'ADDBNB.COM',
              ticker: 'ADDBNB.COM',
              address: '0x617bf230a6886accec5952385eed8bc85d1a09b2',
              rawAmount: '29998899999900',
              decimal: 8,
              amount: '299988.999999',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'POWNFT.NET',
              ticker: 'POWNFT.NET',
              address: '0x893c25c46bfaa9b66cd557837d32af3fe264a07b',
              rawAmount: '96816550000000000000000',
              decimal: 18,
              amount: '96816.55',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MINIDOGE',
              ticker: 'MINIDOGE',
              address: '0x9b1ba20ae9335197c72be094d4fa300d4ef95351',
              rawAmount: '500000000000000000000000000000',
              decimal: 18,
              amount: '500000000000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'FIFA',
              ticker: 'FIFA',
              address: '0xe19417837d8e61f17dfae2e6a11b1e4810dae2a5',
              rawAmount: '99000000000000',
              decimal: 18,
              amount: '0.000099',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MDT',
              ticker: 'MDT',
              address: '0x668db7aa38eac6b40c9d13dbe61361dc4c4611d1',
              rawAmount: '4965562423',
              decimal: 18,
              amount: '0.000000004965562423',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ZIL',
              ticker: 'ZIL',
              address: '0xb86abcb37c3a4b64f74f59301aff131a1becc787',
              rawAmount: '5995',
              decimal: 12,
              amount: '0.000000005995',
              logo: 'https://api.rango.exchange/i/aiPfMq',
              usdPrice: 0.0176,
            },
            {
              chain: 'BSC',
              symbol: ' "995$ VISIT USDTREWARD.COM TO CLAIM',
              ticker: ' "995$ VISIT USDTREWARD.COM TO CLAIM',
              address: '0x67c4a6da86da4f45030904b143d6b00d25e366e9',
              rawAmount: '6',
              decimal: 0,
              amount: '6',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'ADA',
              ticker: 'ADA',
              address: '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47',
              rawAmount: '6081419213',
              decimal: 18,
              amount: '0.000000006081419213',
              logo: 'https://api.rango.exchange/i/ne4pEv',
              usdPrice: 0.25,
            },
            {
              chain: 'BSC',
              symbol: 'ZEPE.IO',
              ticker: 'ZEPE.IO',
              address: '0xb0557906c617f0048a700758606f64b33d0c41a6',
              rawAmount: '750000000000000000000000',
              decimal: 18,
              amount: '750000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MN',
              ticker: 'MN',
              address: '0x1a09f518a8293d519de20700076ad9cd2125d224',
              rawAmount: '454000000000000',
              decimal: 18,
              amount: '0.000454',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'EVER',
              ticker: 'EVER',
              address: '0x5190b01965b6e3d786706fd4a999978626c19880',
              rawAmount: '800000000000000000000000',
              decimal: 18,
              amount: '800000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'SGC',
              ticker: 'SGC',
              address: '0x7aa3a53360541283ffa9192972223b47a902dc0c',
              rawAmount: '1450000000000',
              decimal: 6,
              amount: '1450000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BCH',
              ticker: 'BCH',
              address: '0x8ff795a6f4d97e7887c79bea79aba5cc76444adf',
              rawAmount: '208175286',
              decimal: 18,
              amount: '0.000000000208175286',
              logo: 'https://api.rango.exchange/i/TPdCZV',
              usdPrice: 101.758,
            },
            {
              chain: 'BSC',
              symbol: 'KK8.IO',
              ticker: 'KK8.IO',
              address: '0x2ba6204c23fbd5698ed90abc911de263e5f41266',
              rawAmount: '166574000000000000000000',
              decimal: 18,
              amount: '166574',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'BCNFT',
              ticker: 'BCNFT',
              address: '0xe5677103191711bad85cf99e0dfc9b35449b790b',
              rawAmount: '99800000000000000000',
              decimal: 18,
              amount: '99.8',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'MNFLX',
              ticker: 'MNFLX',
              address: '0xa04f060077d90fe2647b61e4da4ad1f97d6649dc',
              rawAmount: '18298000000000000',
              decimal: 18,
              amount: '0.018298',
              logo: 'https://api.rango.exchange/i/66c2BP',
              usdPrice: null,
            },
            {
              chain: 'BSC',
              symbol: 'FIL',
              ticker: 'FIL',
              address: '0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153',
              rawAmount: '166801647873165921',
              decimal: 18,
              amount: '0.166801647873165921',
              logo: 'https://api.rango.exchange/i/diq2au',
              usdPrice: 2.925,
            },
            {
              chain: 'BSC',
              symbol: 'DAI',
              ticker: 'DAI',
              address: '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
              rawAmount: '7308178549281467169',
              decimal: 18,
              amount: '7.308178549281467169',
              logo: 'https://api.rango.exchange/i/EcBuF8',
              usdPrice: 1.002,
            },
            {
              chain: 'BSC',
              symbol: 'BNB',
              ticker: 'BNB',
              address: null,
              rawAmount: '64638855809280692',
              decimal: 18,
              amount: '0.064638855809280692',
              logo: 'https://api.rango.exchange/i/Y3v1KW',
              usdPrice: null,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://bscscan.com/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'POLYGON',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [],
          loading: false,
          walletType: 'metamask',
          isConnected: true,
          error: true,
          explorerUrl:
            'https://polygonscan.com/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'ETH',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'ETH',
              symbol: 'BAT',
              ticker: 'BAT',
              address: '0x0d8775f648430679a709e98d2b0cb6250d2887ef',
              rawAmount: '4000000000000000000',
              decimal: 18,
              amount: '4',
              logo: 'https://api.rango.exchange/i/fRlt4J',
              usdPrice: 0.187,
            },
            {
              chain: 'ETH',
              symbol: 'WBTC',
              ticker: 'WBTC',
              address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
              rawAmount: '4777',
              decimal: 8,
              amount: '0.00004777',
              logo: 'https://api.rango.exchange/i/LZSo9D',
              usdPrice: 16748.345,
            },
            {
              chain: 'ETH',
              symbol: 'BUSD',
              ticker: 'BUSD',
              address: '0x4fabb145d64652a948d72533023f6e7a623c7c53',
              rawAmount: '44533649981450616971',
              decimal: 18,
              amount: '44.533649981450616971',
              logo: 'https://api.rango.exchange/i/sQLw6p',
              usdPrice: 0.996,
            },
            {
              chain: 'ETH',
              symbol: 'USDC',
              ticker: 'USDC',
              address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
              rawAmount: '68026943',
              decimal: 6,
              amount: '68.026943',
              logo: 'https://api.rango.exchange/i/ns0AMf',
              usdPrice: 0.998,
            },
            {
              chain: 'ETH',
              symbol: 'WETH',
              ticker: 'WETH',
              address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
              rawAmount: '69476760000000000',
              decimal: 18,
              amount: '0.06947676',
              logo: 'https://api.rango.exchange/i/yZ9N1N',
              usdPrice: 1207.06,
            },
            {
              chain: 'ETH',
              symbol: 'USDT',
              ticker: 'USDT',
              address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
              rawAmount: '458820363',
              decimal: 6,
              amount: '458.820363',
              logo: 'https://api.rango.exchange/i/aR1yFx',
              usdPrice: 0.999,
            },
            {
              chain: 'ETH',
              symbol: 'RENBTC',
              ticker: 'RENBTC',
              address: '0xeb4c2781e4eba804ce9a9803c67d0893436bb27d',
              rawAmount: '92825',
              decimal: 8,
              amount: '0.00092825',
              logo: 'https://api.rango.exchange/i/kwXCDn',
              usdPrice: 17122.537,
            },
            {
              chain: 'ETH',
              symbol: 'ETH',
              ticker: 'ETH',
              address: null,
              rawAmount: '216333389734077345',
              decimal: 18,
              amount: '0.216333389734077345',
              logo: 'https://api.rango.exchange/i/MTyH5i',
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'MATIC',
              ticker: 'MATIC',
              address: '0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0',
              rawAmount: '31663446408882142552',
              decimal: 18,
              amount: '31.663446408882142552',
              logo: 'https://api.rango.exchange/i/xt6ATN',
              usdPrice: 0.79,
            },
            {
              chain: 'ETH',
              symbol: 'DAI',
              ticker: 'DAI',
              address: '0x6b175474e89094c44da98b954eedeac495271d0f',
              rawAmount: '1987151466068153485',
              decimal: 18,
              amount: '1.987151466068153485',
              logo: 'https://api.rango.exchange/i/yJvJre',
              usdPrice: 0.999,
            },
            {
              chain: 'ETH',
              symbol: 'TUSD',
              ticker: 'TUSD',
              address: '0x0000000000085d4780b73119b644ae5ecd22b376',
              rawAmount: '16993200000000000000',
              decimal: 18,
              amount: '16.9932',
              logo: 'https://api.rango.exchange/i/af3mkt',
              usdPrice: 0.994,
            },
            {
              chain: 'ETH',
              symbol: 'SUSHI',
              ticker: 'SUSHI',
              address: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2',
              rawAmount: '3943357318101926305',
              decimal: 18,
              amount: '3.943357318101926305',
              logo: 'https://api.rango.exchange/i/2GXZEZ',
              usdPrice: 0.951,
            },
            {
              chain: 'ETH',
              symbol: 'AAVE',
              ticker: 'AAVE',
              address: '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9',
              rawAmount: '25162269244382386',
              decimal: 18,
              amount: '0.025162269244382386',
              logo: 'https://api.rango.exchange/i/ZizYhl',
              usdPrice: 55.363,
            },
            {
              chain: 'ETH',
              symbol: 'PERP',
              ticker: 'PERP',
              address: '0xbc396689893d065f41bc2c6ecbee5e0085233447',
              rawAmount: '6774928920',
              decimal: 18,
              amount: '0.00000000677492892',
              logo: 'https://api.rango.exchange/i/VrMbR6',
              usdPrice: 0.39,
            },
            {
              chain: 'ETH',
              symbol: 'STETH',
              ticker: 'STETH',
              address: '0xae7ab96520de3a18e5e111b5eaab095312d7fe84',
              rawAmount: '39341623',
              decimal: 18,
              amount: '0.000000000039341623',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'SHIB',
              ticker: 'SHIB',
              address: '0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce',
              rawAmount: '414477447646226736858871',
              decimal: 18,
              amount: '414477.447646226736858871',
              logo: 'https://api.rango.exchange/i/cbCyuY',
              usdPrice: 0.00000824,
            },
            {
              chain: 'ETH',
              symbol: 'EROWAN',
              ticker: 'EROWAN',
              address: '0x07bac35846e5ed502aa91adf6a9e7aa210f2dcbe',
              rawAmount: '17095432307032160581',
              decimal: 18,
              amount: '17.095432307032160581',
              logo: 'https://api.rango.exchange/i/X97ibo',
              usdPrice: 0.000317,
            },
            {
              chain: 'ETH',
              symbol: 'UST',
              ticker: 'UST',
              address: '0xa693b19d2931d498c5b318df961919bb4aee87a5',
              rawAmount: '1000000',
              decimal: 6,
              amount: '1',
              logo: 'https://api.rango.exchange/i/IvLUkp',
              usdPrice: 0.02,
            },
            {
              chain: 'ETH',
              symbol: 'XDATA',
              ticker: 'XDATA',
              address: '0x0cf0ee63788a0849fe5297f3407f701e122cc023',
              rawAmount: '230414265395638755692',
              decimal: 18,
              amount: '230.414265395638755692',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'bETH',
              ticker: 'bETH',
              address: '0x707f9118e33a9b8998bea41dd0d46f38bb963fc8',
              rawAmount: '184000000000000',
              decimal: 18,
              amount: '0.000184',
              logo: 'https://api.rango.exchange/tokens/TERRA/BETH.png',
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'AKSWAP.IO',
              ticker: 'AKSWAP.IO',
              address: '0x82dfdb2ec1aa6003ed4acba663403d7c2127ff67',
              rawAmount: '250000000000000000000000',
              decimal: 18,
              amount: '250000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'WBNB',
              ticker: 'WBNB',
              address: '0x418d75f65a02b3d53b2418fb8e1fe493759c7605',
              rawAmount: '10000000000000000',
              decimal: 18,
              amount: '0.01',
              logo: 'https://api.rango.exchange/i/Xzflek',
              usdPrice: 248.36,
            },
            {
              chain: 'ETH',
              symbol: 'RANGO',
              ticker: 'RANGO',
              address: '0x5846d81d8e4a3b9cc53ce1dcdc12b6619ae3507d',
              rawAmount: '40000000',
              decimal: 6,
              amount: '40',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'LUNAV2.IO (LUNA TOKEN)',
              ticker: 'LUNAV2.IO (LUNA TOKEN)',
              address: '0xaf0b2fbedd5d1fda457580fb3dabad1f5c8bbc36',
              rawAmount: '258542000000000000000000',
              decimal: 18,
              amount: '258542',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'LUNA 2.0 (LUNAV2.IO)',
              ticker: 'LUNA 2.0 (LUNAV2.IO)',
              address: '0x471c3a7f132bc94938516cb2bf6f02c7521d2797',
              rawAmount: '250457000000000000000000',
              decimal: 18,
              amount: '250457',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'LIDOLP.COM',
              ticker: 'LIDOLP.COM',
              address: '0x0332d00ae8e9baa609edc48844f48fdd94ca9547',
              rawAmount: '6000',
              decimal: 0,
              amount: '6000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'HBOT',
              ticker: 'HBOT',
              address: '0xe5097d9baeafb89f9bcb78c9290d545db5f9e9cb',
              rawAmount: '155042558533708582423',
              decimal: 18,
              amount: '155.042558533708582423',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: '1650811245.077F',
              ticker: '1650811245.077F',
              address: '0xba8d75baccc4d5c4bd814fde69267213052ea663',
              rawAmount: '1000000000000000000',
              decimal: 18,
              amount: '1',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'PWING',
              ticker: 'PWING',
              address: '0xdb0f18081b505a7de20b18ac41856bcb4ba86a1a',
              rawAmount: '498133925',
              decimal: 9,
              amount: '0.498133925',
              logo: 'https://api.rango.exchange/i/Ba5IQF',
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'VISIT [AAVE-SR.XYZ] AND CLAIM SPECIAL REWARDS',
              ticker: 'VISIT [AAVE-SR.XYZ] AND CLAIM SPECIAL REWARDS',
              address: '0xd1e61fcb6e26d4deffa77f21cc5b581c3afa95e2',
              rawAmount: '920816400',
              decimal: 6,
              amount: '920.8164',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'VISIT [AUSD.SHOP] AND SUPPLY OR BORROW USDT',
              ticker: 'VISIT [AUSD.SHOP] AND SUPPLY OR BORROW USDT',
              address: '0x38715ab4b9d4e00890773d7338d94778b0dfc0a8',
              rawAmount: '2294101815',
              decimal: 6,
              amount: '2294.101815',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: '[LIDOSR.XYZ] CLAIM YOUR SPECIAL REWARDS.',
              ticker: '[LIDOSR.XYZ] CLAIM YOUR SPECIAL REWARDS.',
              address: '0x511b5f248269c0b90b60e33ef9df744048c84a83',
              rawAmount: '149260000',
              decimal: 6,
              amount: '149.26',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'ENJOY [HTTPS://SPINGAME.ME]',
              ticker: 'ENJOY [HTTPS://SPINGAME.ME]',
              address: '0xcdc94877e4164d2e915fc5e8310155d661a995f1',
              rawAmount: '2294101815',
              decimal: 6,
              amount: '2294.101815',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: 'WMATIC',
              ticker: 'WMATIC',
              address: '0x7c9f4c87d911613fe9ca58b579f737911aad2d43',
              rawAmount: '100000000000000000',
              decimal: 18,
              amount: '0.1',
              logo: 'https://api.rango.exchange/i/QpOgNr',
              usdPrice: null,
            },
            {
              chain: 'ETH',
              symbol: '$ VISIT NFTGIFTX.COM TO CLAIM',
              ticker: '$ VISIT NFTGIFTX.COM TO CLAIM',
              address: '0x0d3716e3e411af431a6e87e715d4b05bbcd67000',
              rawAmount: '4000',
              decimal: 0,
              amount: '4000',
              logo: null,
              usdPrice: null,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://etherscan.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'AVAX_CCHAIN',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'BNB',
              ticker: 'BNB',
              address: '0x264c1383ea520f73dd837f915ef3a732e204a493',
              rawAmount: '7107381667',
              decimal: 18,
              amount: '0.000000007107381667',
              logo: 'https://api.rango.exchange/i/BtRUoA',
              usdPrice: 247.386,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'TUSD',
              ticker: 'TUSD',
              address: '0x1c20e891bab6b1727d14da358fae2984ed9b59eb',
              rawAmount: '2819919094',
              decimal: 18,
              amount: '0.000000002819919094',
              logo: 'https://api.rango.exchange/i/UBghmk',
              usdPrice: 1,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'SOL',
              ticker: 'SOL',
              address: '0xfe6b19286885a4f7f55adad09c3cd1f906d2478f',
              rawAmount: '110',
              decimal: 9,
              amount: '0.00000011',
              logo: 'https://api.rango.exchange/i/YhJ1nK',
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'OPENDAO.IS',
              ticker: 'OPENDAO.IS',
              address: '0xc03f94e49c944c4f118c3f97af7cce8f01df9430',
              rawAmount: '10000000000000000000',
              decimal: 18,
              amount: '10',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'IMX.A',
              ticker: 'IMX.A',
              address: '0xea6887e4a9cda1b77e70129e5fba830cdb5cddef',
              rawAmount: '7119477388984802736',
              decimal: 18,
              amount: '7.119477388984802736',
              logo: 'https://api.rango.exchange/i/qhi6I3',
              usdPrice: 0.000139,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'AVAXCLASSIC.COM',
              ticker: 'AVAXCLASSIC.COM',
              address: '0x4c4f4f4122c3a80d30c1ad6ad2828953015bd52c',
              rawAmount: '74041750000000000000',
              decimal: 18,
              amount: '74.04175',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'ORBS',
              ticker: 'ORBS',
              address: '0x340fe1d898eccaad394e2ba0fc1f93d27c7b717a',
              rawAmount: '7336115152',
              decimal: 18,
              amount: '0.000000007336115152',
              logo: 'https://api.rango.exchange/i/hktmCG',
              usdPrice: 0.0228,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'PENDLE',
              ticker: 'PENDLE',
              address: '0xfb98b335551a418cd0737375a2ea0ded62ea213b',
              rawAmount: '43168168325557885527',
              decimal: 18,
              amount: '43.168168325557885527',
              logo: 'https://api.rango.exchange/i/p4dkte',
              usdPrice: 0.046,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'WMATIC',
              ticker: 'WMATIC',
              address: '0xf2f13f0b7008ab2fa4a2418f4ccc3684e49d20eb',
              rawAmount: '45499998000000000000',
              decimal: 18,
              amount: '45.499998',
              logo: 'https://api.rango.exchange/i/QpOgNr',
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'avaxUSDC',
              ticker: 'avaxUSDC',
              address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
              rawAmount: '15844946',
              decimal: 6,
              amount: '15.844946',
              logo: 'https://api.rango.exchange/i/FHj2LZ',
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'SPELL',
              ticker: 'SPELL',
              address: '0xce1bffbd5374dac86a2893119683f4911a2f7814',
              rawAmount: '144687727088072773130',
              decimal: 18,
              amount: '144.68772708807277313',
              logo: 'https://api.rango.exchange/i/zW5ZK2',
              usdPrice: 0.000535,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'WBNB',
              ticker: 'WBNB',
              address: '0x442f7f22b1ee2c842beaff52880d4573e9201158',
              rawAmount: '57933890000000000',
              decimal: 18,
              amount: '0.05793389',
              logo: 'https://api.rango.exchange/i/Xzflek',
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'GMX',
              ticker: 'GMX',
              address: '0x62edc0692bd897d2295872a9ffcac5425011c661',
              rawAmount: '379543333707025854',
              decimal: 18,
              amount: '0.379543333707025854',
              logo: 'https://api.rango.exchange/i/0aQTDd',
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'JOE',
              ticker: 'JOE',
              address: '0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd',
              rawAmount: '35980183723492368253',
              decimal: 18,
              amount: '35.980183723492368253',
              logo: 'https://api.rango.exchange/i/Vw0Fv2',
              usdPrice: 0.141,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'WETH.E',
              ticker: 'WETH.E',
              address: '0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab',
              rawAmount: '17684493183273648',
              decimal: 18,
              amount: '0.017684493183273648',
              logo: 'https://api.rango.exchange/i/j9xgdC',
              usdPrice: 1210.2,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'UST',
              ticker: 'UST',
              address: '0xb599c3590f42f8f995ecfa0f85d2980b76862fc1',
              rawAmount: '3993',
              decimal: 6,
              amount: '0.003993',
              logo: 'https://api.rango.exchange/i/0lk6id',
              usdPrice: 0.02,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'USDT',
              ticker: 'USDT',
              address: '0xde3a24028580884448a5397872046a019649b084',
              rawAmount: '35748023',
              decimal: 6,
              amount: '35.748023',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: '24DROP.NET',
              ticker: '24DROP.NET',
              address: '0x2be494c06316c0d7371250419a9c659a0752ecb3',
              rawAmount: '200000000000',
              decimal: 8,
              amount: '2000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'WETH',
              ticker: 'WETH',
              address: '0x8b82a291f83ca07af22120aba21632088fc92931',
              rawAmount: '5200000000000000',
              decimal: 18,
              amount: '0.0052',
              logo: 'https://api.rango.exchange/i/wNnplE',
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: '0006648936.E9CB',
              ticker: '0006648936.E9CB',
              address: '0x38dcf0532699b880e6a125f7d918380524cd60a6',
              rawAmount: '10000000000000000000',
              decimal: 18,
              amount: '10',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: '$ FREE CLAIM AND PLAY',
              ticker: '$ FREE CLAIM AND PLAY',
              address: '0xd23345e0e6340616b1cf7200762d0289547ccf87',
              rawAmount: '50000000000',
              decimal: 8,
              amount: '500',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'AMPL',
              ticker: 'AMPL',
              address: '0x027dbca046ca156de9622cd1e2d907d375e53aa7',
              rawAmount: '8302538186',
              decimal: 9,
              amount: '8.302538186',
              logo: 'https://api.rango.exchange/i/AiXtEj',
              usdPrice: 1.078,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'USDT',
              ticker: 'USDT',
              address: '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7',
              rawAmount: '35280647',
              decimal: 6,
              amount: '35.280647',
              logo: 'https://api.rango.exchange/i/9e1hH8',
              usdPrice: 1.005,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'MNEAV',
              ticker: 'MNEAV',
              address: '0xf9d922c055a3f1759299467dafafdf43be844f7a',
              rawAmount: '30000000000000',
              decimal: 8,
              amount: '300000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'USDC.E',
              ticker: 'USDC.E',
              address: '0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664',
              rawAmount: '92749613',
              decimal: 6,
              amount: '92.749613',
              logo: 'https://api.rango.exchange/i/j9eYAa',
              usdPrice: 1,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'BLIZZ',
              ticker: 'BLIZZ',
              address: '0xb147656604217a03fe2c73c4838770df8d9d21b8',
              rawAmount: '135470487277154696313',
              decimal: 18,
              amount: '135.470487277154696313',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'USDT',
              ticker: 'USDT',
              address: '0xc7198437980c041c805a1edcba50c1ce5db95118',
              rawAmount: '36943578',
              decimal: 6,
              amount: '36.943578',
              logo: 'https://api.rango.exchange/i/niIihm',
              usdPrice: null,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'MIM',
              ticker: 'MIM',
              address: '0x130966628846bfd36ff31a822705796e8cb8c18d',
              rawAmount: '13661627814282704200',
              decimal: 18,
              amount: '13.6616278142827042',
              logo: 'https://api.rango.exchange/i/RmsZZl',
              usdPrice: 0.998,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'WAVAX',
              ticker: 'WAVAX',
              address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
              rawAmount: '553221840010000000',
              decimal: 18,
              amount: '0.55322184001',
              logo: 'https://api.rango.exchange/i/9bwFaG',
              usdPrice: 11.97,
            },
            {
              chain: 'AVAX_CCHAIN',
              symbol: 'AVAX',
              ticker: 'AVAX',
              address: null,
              rawAmount: '3293457782165450159',
              decimal: 18,
              amount: '3.293457782165450159',
              logo: 'https://api.rango.exchange/i/kX4edQ',
              usdPrice: 11.77,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://snowtrace.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'ARBITRUM',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'ARBITRUM',
              symbol: 'JONES',
              ticker: 'JONES',
              address: '0x10393c20975cf177a3513071bc110f7962cd67da',
              rawAmount: '1933131668197791405',
              decimal: 18,
              amount: '1.933131668197791405',
              logo: 'https://api.rango.exchange/i/FUexNn',
              usdPrice: null,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'DAI',
              ticker: 'DAI',
              address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
              rawAmount: '19526880162738340394',
              decimal: 18,
              amount: '19.526880162738340394',
              logo: 'https://api.rango.exchange/i/yJvJre',
              usdPrice: 1,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'MAGIC',
              ticker: 'MAGIC',
              address: '0x539bde0d7dbd336b79148aa742883198bbf60342',
              rawAmount: '9059590242',
              decimal: 18,
              amount: '0.000000009059590242',
              logo: 'https://api.rango.exchange/i/tazAGH',
              usdPrice: null,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'UNI',
              ticker: 'UNI',
              address: '0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0',
              rawAmount: '2392264468',
              decimal: 18,
              amount: '0.000000002392264468',
              logo: 'https://api.rango.exchange/i/n8RX8F',
              usdPrice: 5.246,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'HND',
              ticker: 'HND',
              address: '0x10010078a54396f62c96df8532dc2b4847d47ed3',
              rawAmount: '150921229948215461100',
              decimal: 18,
              amount: '150.9212299482154611',
              logo: 'https://api.rango.exchange/i/2SsRdS',
              usdPrice: null,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'GMX',
              ticker: 'GMX',
              address: '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a',
              rawAmount: '128216748136770842',
              decimal: 18,
              amount: '0.128216748136770842',
              logo: 'https://api.rango.exchange/i/vCEMKq',
              usdPrice: 46.259,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'RIFTDAO.NET',
              ticker: 'RIFTDAO.NET',
              address: '0xe1cc7371f2c2b7ebb1af2b0c053ec86596e3f6d0',
              rawAmount: '738097000000000000000000',
              decimal: 18,
              amount: '738097',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'USDT',
              ticker: 'USDT',
              address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
              rawAmount: '40064700',
              decimal: 6,
              amount: '40.0647',
              logo: 'https://api.rango.exchange/i/aR1yFx',
              usdPrice: 1,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'BADGER',
              ticker: 'BADGER',
              address: '0xbfa641051ba0a0ad1b0acf549a89536a0d76472e',
              rawAmount: '2089136975803812618',
              decimal: 18,
              amount: '2.089136975803812618',
              logo: 'https://api.rango.exchange/i/aaEEDq',
              usdPrice: 2.26,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'USDC',
              ticker: 'USDC',
              address: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
              rawAmount: '55298622',
              decimal: 6,
              amount: '55.298622',
              logo: 'https://api.rango.exchange/i/ns0AMf',
              usdPrice: 1,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'MIM',
              ticker: 'MIM',
              address: '0xfea7a6a0b346362bf88a9e4a88416b77a57d6c2a',
              rawAmount: '10100000000000000000',
              decimal: 18,
              amount: '10.1',
              logo: 'https://api.rango.exchange/i/JKT05f',
              usdPrice: 0.998,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'AXLUSDC',
              ticker: 'AXLUSDC',
              address: '0xeb466342c4d449bc9f53a865d5cb90586f405215',
              rawAmount: '5500000',
              decimal: 6,
              amount: '5.5',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'ARBITRUM',
              symbol: 'ETH',
              ticker: 'ETH',
              address: null,
              rawAmount: '82905399282605538',
              decimal: 18,
              amount: '0.082905399282605538',
              logo: 'https://api.rango.exchange/i/MTyH5i',
              usdPrice: null,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://arbiscan.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'FANTOM',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'FANTOM',
              symbol: 'FBNB',
              ticker: 'FBNB',
              address: '0x27f26f00e1605903645bbabc0a73e35027dccd45',
              rawAmount: '15851797577951',
              decimal: 18,
              amount: '0.000015851797577951',
              logo: 'https://api.rango.exchange/tokens/FANTOM/FBNB.png',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'WETH',
              ticker: 'WETH',
              address: '0x74b23882a30290451a17c44f4f05243b6b58c76d',
              rawAmount: '2171678666801825',
              decimal: 18,
              amount: '0.002171678666801825',
              logo: 'https://api.rango.exchange/tokens/FANTOM/WETH.png',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'FXS',
              ticker: 'FXS',
              address: '0x7d016eec9c25232b01f23ef992d98ca97fc2af5a',
              rawAmount: '8129029359551099',
              decimal: 18,
              amount: '0.008129029359551099',
              logo: 'https://api.rango.exchange/i/TVDwaE',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'WAVAX',
              ticker: 'WAVAX',
              address: '0x511d35c52a3c244e7b8bd92c0c297755fbd89212',
              rawAmount: '103423419794091413',
              decimal: 18,
              amount: '0.103423419794091413',
              logo: 'https://api.rango.exchange/tokens/FANTOM/WAVAX.png',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'WOO',
              ticker: 'WOO',
              address: '0x6626c47c00f1d87902fc13eecfac3ed06d5e8d8a',
              rawAmount: '3069453396',
              decimal: 18,
              amount: '0.000000003069453396',
              logo: 'https://api.rango.exchange/i/UuEujP',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'SWAPFTM.COM',
              ticker: 'SWAPFTM.COM',
              address: '0x87e377820010d818aa316f8c3f1c2b9d025eb5ee',
              rawAmount: '100000000000000000000',
              decimal: 18,
              amount: '100',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'BIFI',
              ticker: 'BIFI',
              address: '0xd6070ae98b8069de6b494332d1a1a81b6179d960',
              rawAmount: '5427265333',
              decimal: 18,
              amount: '0.000000005427265333',
              logo: 'https://api.rango.exchange/i/euTXdM',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'BNB',
              ticker: 'BNB',
              address: '0xd67de0e0a0fd7b15dc8348bb9be742f3c5850454',
              rawAmount: '4343993985',
              decimal: 18,
              amount: '0.000000004343993985',
              logo: 'https://api.rango.exchange/i/Yj2w83',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'NUSD',
              ticker: 'NUSD',
              address: '0xed2a7edd7413021d440b09d654f3b87712abab66',
              rawAmount: '1993985245375892955',
              decimal: 18,
              amount: '1.993985245375892955',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'MIM',
              ticker: 'MIM',
              address: '0x82f0b8b456c1a451378467398982d4834b6829c1',
              rawAmount: '38400000001430563305',
              decimal: 18,
              amount: '38.400000001430563305',
              logo: 'https://api.rango.exchange/i/ceBRSU',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: '888CRYPTO.PRO',
              ticker: '888CRYPTO.PRO',
              address: '0x7082ca5058c358997063400ad78306b16a5c30d9',
              rawAmount: '150000000000000',
              decimal: 8,
              amount: '1500000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: '2XCO',
              ticker: '2XCO',
              address: '0xcaef42682040a19e09eb8a6773f17da81b0604c1',
              rawAmount: '9500000000000',
              decimal: 8,
              amount: '95000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: '$ AIRDROP IN CAKE (MULTICHAIN)',
              ticker: '$ AIRDROP IN CAKE (MULTICHAIN)',
              address: '0xb502b79c9ec490c4eee130a03370d490b069e59b',
              rawAmount: '50000000000',
              decimal: 8,
              amount: '500',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'USDC',
              ticker: 'USDC',
              address: '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
              rawAmount: '268477851',
              decimal: 6,
              amount: '268.477851',
              logo: 'https://api.rango.exchange/i/pva3ih',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: '0CASINO.IO',
              ticker: '0CASINO.IO',
              address: '0x383c5e5a05ba830579adc2fccd6403894e1caa59',
              rawAmount: '150000000000000',
              decimal: 8,
              amount: '1500000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'WFTM',
              ticker: 'WFTM',
              address: '0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83',
              rawAmount: '262664414658966373114',
              decimal: 18,
              amount: '262.664414658966373114',
              logo: 'https://api.rango.exchange/i/auYSf8',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'ETH-1INCH.IO',
              ticker: 'ETH-1INCH.IO',
              address: '0x5a7aad61871a39a972c11aa9cd48e8df1e10311d',
              rawAmount: '870000000000000000',
              decimal: 18,
              amount: '0.87',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'BUSD',
              ticker: 'BUSD',
              address: '0xc931f61b1534eb21d8c11b24f3f5ab2471d4ab50',
              rawAmount: '996216277676653329',
              decimal: 18,
              amount: '0.996216277676653329',
              logo: 'https://api.rango.exchange/i/zOV927',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'DAI',
              ticker: 'DAI',
              address: '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
              rawAmount: '6907579712',
              decimal: 18,
              amount: '0.000000006907579712',
              logo: 'https://api.rango.exchange/i/iIxCAk',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'RBNB',
              ticker: 'RBNB',
              address: '0xc3394bb9b118b3c9b5b8da297e20c08878edbed4',
              rawAmount: '100000000000000',
              decimal: 18,
              amount: '0.0001',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'IMX',
              ticker: 'IMX',
              address: '0xea38f1ccf77bf43f352636241b05dd8f6f5f52b2',
              rawAmount: '116509710',
              decimal: 18,
              amount: '0.00000000011650971',
              logo: 'https://api.rango.exchange/i/3nnwQN',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: '24DROP.NET',
              ticker: '24DROP.NET',
              address: '0x67a58a20f087a600aec491d5cd329ba597b71aa7',
              rawAmount: '200000000000',
              decimal: 8,
              amount: '2000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'MNEF',
              ticker: 'MNEF',
              address: '0xf9d922c055a3f1759299467dafafdf43be844f7a',
              rawAmount: '30000000000000',
              decimal: 8,
              amount: '300000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: ' 0VISIT [003ERRORNOTICE.COM] TO SECURE YOUR FUNDS.',
              ticker: ' 0VISIT [003ERRORNOTICE.COM] TO SECURE YOUR FUNDS.',
              address: '0x98e4b3866602fc72ff766616e15146c9153b473b',
              rawAmount: '2200000000000000000000',
              decimal: 18,
              amount: '2200',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: '0CASINO.IO',
              ticker: '0CASINO.IO',
              address: '0xbe1b23d652580052dd8e774e0e7e92cf5cc31bb3',
              rawAmount: '150000000000000',
              decimal: 8,
              amount: '1500000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'CRV',
              ticker: 'CRV',
              address: '0x1e4f97b9f9f913c46f1632781732927b9019c68b',
              rawAmount: '2433604212107615486',
              decimal: 18,
              amount: '2.433604212107615486',
              logo: 'https://api.rango.exchange/i/60avSg',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: '4GAMBLING.IO',
              ticker: '4GAMBLING.IO',
              address: '0xe4517100ae62cbeefc363e59d0f8df5754dc7e40',
              rawAmount: '300000000000000',
              decimal: 8,
              amount: '3000000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'USDT',
              ticker: 'USDT',
              address: '0x049d68029688eabf473097a2fc38ef61633a3c7a',
              rawAmount: '63082358',
              decimal: 6,
              amount: '63.082358',
              logo: 'https://api.rango.exchange/i/niIihm',
              usdPrice: null,
            },
            {
              chain: 'FANTOM',
              symbol: 'FTM',
              ticker: 'FTM',
              address: null,
              rawAmount: '1346689531144440162650',
              decimal: 18,
              amount: '1346.68953114444016265',
              logo: 'https://api.rango.exchange/i/JC2fWD',
              usdPrice: null,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://ftmscan.com/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'OPTIMISM',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'OPTIMISM',
              symbol: 'USDT',
              ticker: 'USDT',
              address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
              rawAmount: '22874529',
              decimal: 6,
              amount: '22.874529',
              logo: 'https://api.rango.exchange/i/K6j5VN',
              usdPrice: 1,
            },
            {
              chain: 'OPTIMISM',
              symbol: 'USDC',
              ticker: 'USDC',
              address: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
              rawAmount: '39610548',
              decimal: 6,
              amount: '39.610548',
              logo: 'https://api.rango.exchange/i/e4x0s8',
              usdPrice: 0.999,
            },
            {
              chain: 'OPTIMISM',
              symbol: 'WETH',
              ticker: 'WETH',
              address: '0x4200000000000000000000000000000000000006',
              rawAmount: '30671676019131723',
              decimal: 18,
              amount: '0.030671676019131723',
              logo: 'https://api.rango.exchange/i/yZ9N1N',
              usdPrice: 1207.06,
            },
            {
              chain: 'OPTIMISM',
              symbol: 'DAI',
              ticker: 'DAI',
              address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
              rawAmount: '1535439265',
              decimal: 18,
              amount: '0.000000001535439265',
              logo: 'https://api.rango.exchange/i/zyZx0X',
              usdPrice: 1,
            },
            {
              chain: 'OPTIMISM',
              symbol: 'ETH',
              ticker: 'ETH',
              address: null,
              rawAmount: '3809903995186154',
              decimal: 18,
              amount: '0.003809903995186154',
              logo: 'https://api.rango.exchange/i/MTyH5i',
              usdPrice: null,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://optimistic.etherscan.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'OKC',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: true,
          explorerUrl:
            'https://www.oklink.com/en/okc/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'CRONOS',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'CRONOS',
              symbol: 'WETH',
              ticker: 'WETH',
              address: '0xe44fd7fcb2b1581822d0c862b68222998a0c299a',
              rawAmount: '4788770370',
              decimal: 18,
              amount: '0.00000000478877037',
              logo: 'https://api.rango.exchange/i/j9xgdC',
              usdPrice: 1210.2,
            },
            {
              chain: 'CRONOS',
              symbol: 'AUTO',
              ticker: 'AUTO',
              address: '0x0dcb0cb0120d355cde1ce56040be57add0185baa',
              rawAmount: '43013763072696143',
              decimal: 18,
              amount: '0.043013763072696143',
              logo: 'https://api.rango.exchange/i/YxjmF0',
              usdPrice: 222.98,
            },
            {
              chain: 'CRONOS',
              symbol: 'CRONOSCLASSIC.COM',
              ticker: 'CRONOSCLASSIC.COM',
              address: '0x772c96ed2f99d84c2a83e67fbada9a1db4303be1',
              rawAmount: '9000000000000000000000',
              decimal: 18,
              amount: '9000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'CRONOS',
              symbol: 'BNB',
              ticker: 'BNB',
              address: '0xfa9343c3897324496a05fc75abed6bac29f8a40f',
              rawAmount: '86000000000000000',
              decimal: 18,
              amount: '0.086',
              logo: 'https://api.rango.exchange/i/B4ULZJ',
              usdPrice: 248.28,
            },
            {
              chain: 'CRONOS',
              symbol: 'USDT',
              ticker: 'USDT',
              address: '0x66e428c3f67a68878562e79a0234c1f83c208770',
              rawAmount: '1287808',
              decimal: 6,
              amount: '1.287808',
              logo: 'https://api.rango.exchange/i/GJxbOP',
              usdPrice: 1,
            },
            {
              chain: 'CRONOS',
              symbol: 'CRONOSCLASSIC.COM',
              ticker: 'CRONOSCLASSIC.COM',
              address: '0x75f920403641ddbd66f8ce3ddd3a648ddb496c89',
              rawAmount: '9000000000000000000000',
              decimal: 18,
              amount: '9000',
              logo: null,
              usdPrice: null,
            },
            {
              chain: 'CRONOS',
              symbol: 'CRO',
              ticker: 'CRO',
              address: null,
              rawAmount: '218462428966917726855',
              decimal: 18,
              amount: '218.462428966917726855',
              logo: 'https://api.rango.exchange/i/S3tFKF',
              usdPrice: 0.0579,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://cronoscan.com/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'MOONRIVER',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'MOONRIVER',
              symbol: 'MOVR',
              ticker: 'MOVR',
              address: null,
              rawAmount: '1409467396930959879',
              decimal: 18,
              amount: '1.409467396930959879',
              logo: 'https://api.rango.exchange/i/AKXDjV',
              usdPrice: null,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://moonriver.moonscan.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'MOONBEAM',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'MOONBEAM',
              symbol: 'GLMR',
              ticker: 'GLMR',
              address: null,
              rawAmount: '7637316155712999392',
              decimal: 18,
              amount: '7.637316155712999392',
              logo: 'https://api.rango.exchange/i/Ra0xKh',
              usdPrice: 0.343,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://moonbeam.moonscan.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'HECO',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'HECO',
              symbol: 'HT',
              ticker: 'HT',
              address: null,
              rawAmount: '8900958749249974840',
              decimal: 18,
              amount: '8.90095874924997484',
              logo: 'https://api.rango.exchange/i/9uAYzf',
              usdPrice: 5.361,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://hecoinfo.com/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'AURORA',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'AURORA',
              symbol: 'MATIC',
              ticker: 'MATIC',
              address: '0x6ab6d61428fde76768d7b45d8bfeec19c6ef91a8',
              rawAmount: '4963601767',
              decimal: 18,
              amount: '0.000000004963601767',
              logo: 'https://api.rango.exchange/i/yVbC8U',
              usdPrice: 0.793,
            },
            {
              chain: 'AURORA',
              symbol: 'AVAX',
              ticker: 'AVAX',
              address: '0x80a16016cc4a2e6a2caca8a4a498b1699ff0f844',
              rawAmount: '2088345237',
              decimal: 18,
              amount: '0.000000002088345237',
              logo: 'https://api.rango.exchange/i/kX4edQ',
              usdPrice: 11.77,
            },
            {
              chain: 'AURORA',
              symbol: 'WETH',
              ticker: 'WETH',
              address: '0xc9bdeed33cd01541e1eed10f90519d2c06fe3feb',
              rawAmount: '1000000328916822',
              decimal: 18,
              amount: '0.001000000328916822',
              logo: 'https://api.rango.exchange/i/3h0NwB',
              usdPrice: 1272.743,
            },
            {
              chain: 'AURORA',
              symbol: 'USDC',
              ticker: 'USDC',
              address: '0xb12bfca5a55806aaf64e99521918a4bf0fc40802',
              rawAmount: '25059116',
              decimal: 6,
              amount: '25.059116',
              logo: 'https://api.rango.exchange/i/UfM0ap',
              usdPrice: 0.998,
            },
            {
              chain: 'AURORA',
              symbol: 'USDT',
              ticker: 'USDT',
              address: '0x4988a896b1227218e4a686fde5eabdcabd91571f',
              rawAmount: '9373920',
              decimal: 6,
              amount: '9.37392',
              logo: 'https://api.rango.exchange/i/sq7c5G',
              usdPrice: 1.005,
            },
            {
              chain: 'AURORA',
              symbol: 'ATLUNA',
              ticker: 'ATLUNA',
              address: '0xc4bdd27c33ec7daa6fcfd8532ddb524bf4038096',
              rawAmount: '7269857397',
              decimal: 18,
              amount: '0.000000007269857397',
              logo: 'https://api.rango.exchange/i/kIZ1fy',
              usdPrice: null,
            },
            {
              chain: 'AURORA',
              symbol: 'PICKLE',
              ticker: 'PICKLE',
              address: '0x291c8fceaca3342b29cc36171deb98106f712c66',
              rawAmount: '3462515627985423594',
              decimal: 18,
              amount: '3.462515627985423594',
              logo: 'https://api.rango.exchange/i/LPaa2J',
              usdPrice: null,
            },
            {
              chain: 'AURORA',
              symbol: 'PAPR',
              ticker: 'PAPR',
              address: '0xa5c09de3aa1cdb5cb190be66c77e033be1ca594a',
              rawAmount: '163912004957041283',
              decimal: 18,
              amount: '0.163912004957041283',
              logo: 'https://api.rango.exchange/i/sXsnQu',
              usdPrice: 0.452,
            },
            {
              chain: 'AURORA',
              symbol: 'PRNTR',
              ticker: 'PRNTR',
              address: '0x29daeb6a2a87b159f5fee1f19ec6ccaf4ef2acca',
              rawAmount: '307884579855694445',
              decimal: 18,
              amount: '0.307884579855694445',
              logo: 'https://api.rango.exchange/i/Uf33Cw',
              usdPrice: 0.602,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://explorer.mainnet.aurora.dev/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'HARMONY',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'HARMONY',
              symbol: 'ONE',
              ticker: 'ONE',
              address: null,
              rawAmount: '48801440860746527271',
              decimal: 18,
              amount: '48.801440860746527271',
              logo: 'https://api.rango.exchange/i/gpMxOP',
              usdPrice: 0.109,
            },
            {
              chain: 'HARMONY',
              symbol: '1DAI',
              ticker: '1DAI',
              address: '0xef977d2f931c1978db5f6747666fa1eacb0d0339',
              rawAmount: '3951799808',
              decimal: 18,
              amount: '0.000000003951799808',
              logo: 'https://api.rango.exchange/i/7UdDll',
              usdPrice: 0.961,
            },
            {
              chain: 'HARMONY',
              symbol: '1USDC',
              ticker: '1USDC',
              address: '0x985458e523db3d53125813ed68c274899e9dfab4',
              rawAmount: '4480342',
              decimal: 6,
              amount: '4.480342',
              logo: 'https://api.rango.exchange/i/4eEvKA',
              usdPrice: 1.006,
            },
            {
              chain: 'HARMONY',
              symbol: 'bscBUSD',
              ticker: 'bscBUSD',
              address: '0x0ab43550a6915f9f67d0c454c2e90385e6497eaa',
              rawAmount: '12000000009249314069',
              decimal: 18,
              amount: '12.000000009249314069',
              logo: 'https://api.rango.exchange/i/uZMcKl',
              usdPrice: 0.946,
            },
            {
              chain: 'HARMONY',
              symbol: 'BUSD',
              ticker: 'BUSD',
              address: '0xe176ebe47d621b984a73036b9da5d834411ef734',
              rawAmount: '6201993388439322612',
              decimal: 18,
              amount: '6.201993388439322612',
              logo: 'https://api.rango.exchange/i/qWxf4I',
              usdPrice: 0.84,
            },
            {
              chain: 'HARMONY',
              symbol: 'UST',
              ticker: 'UST',
              address: '0x224e64ec1bdce3870a6a6c777edd450454068fec',
              rawAmount: '5449588252',
              decimal: 18,
              amount: '0.000000005449588252',
              logo: 'https://api.rango.exchange/i/wmyHK9',
              usdPrice: 0.194,
            },
            {
              chain: 'HARMONY',
              symbol: 'WONE',
              ticker: 'WONE',
              address: '0xcf664087a5bb0237a0bad6742852ec6c8d69a27a',
              rawAmount: '2000000000624440839',
              decimal: 18,
              amount: '2.000000000624440839',
              logo: 'https://api.rango.exchange/i/u283bK',
              usdPrice: 0.109,
            },
            {
              chain: 'HARMONY',
              symbol: 'BIFI',
              ticker: 'BIFI',
              address: '0x6ab6d61428fde76768d7b45d8bfeec19c6ef91a8',
              rawAmount: '6500000000000000',
              decimal: 18,
              amount: '0.0065',
              logo: 'https://api.rango.exchange/i/EuFqit',
              usdPrice: 325.37,
            },
            {
              chain: 'HARMONY',
              symbol: 'JENN',
              ticker: 'JENN',
              address: '0x2f459dd7cbcc9d8323621f6fb430cd0555411e7b',
              rawAmount: '82666600666715773',
              decimal: 18,
              amount: '0.082666600666715773',
              logo: 'https://api.rango.exchange/i/5CYmzQ',
              usdPrice: 0.00429,
            },
            {
              chain: 'HARMONY',
              symbol: 'LMA',
              ticker: 'LMA',
              address: '0x7d0546dbb1dca8108d99aa389a8e9ce0c40b2370',
              rawAmount: '2335555755',
              decimal: 18,
              amount: '0.000000002335555755',
              logo: 'https://api.rango.exchange/i/A8Kw4L',
              usdPrice: 33.26,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://explorer.harmony.one/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'EVMOS',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: true,
          explorerUrl:
            'https://evm.evmos.org/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'GNOSIS',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: true,
          explorerUrl:
            'https://blockscout.com/xdai/mainnet/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'FUSE',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: true,
          explorerUrl:
            'https://explorer.fuse.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
    {
      name: 'BOBA',
      accounts: [
        {
          address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
          balances: [
            {
              chain: 'BOBA',
              symbol: 'MIM',
              ticker: 'MIM',
              address: '0x218c3c3d49d0e7b37aff0d8bb079de36ae61a4c0',
              rawAmount: '105604450000000000',
              decimal: 18,
              amount: '0.10560445',
              logo: 'https://api.rango.exchange/i/RmsZZl',
              usdPrice: 0.998,
            },
            {
              chain: 'BOBA',
              symbol: 'BUSD',
              ticker: 'BUSD',
              address: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
              rawAmount: '5431734874',
              decimal: 18,
              amount: '0.000000005431734874',
              logo: 'https://api.rango.exchange/i/PsiPay',
              usdPrice: 0.999,
            },
            {
              chain: 'BOBA',
              symbol: 'UNIDX',
              ticker: 'UNIDX',
              address: '0x375488f097176507e39b9653b88fdc52cde736bf',
              rawAmount: '23224657182604680757',
              decimal: 18,
              amount: '23.224657182604680757',
              logo: 'https://api.rango.exchange/i/TZv5rn',
              usdPrice: 2.3,
            },
            {
              chain: 'BOBA',
              symbol: 'BANA',
              ticker: 'BANA',
              address: '0xc67b9b1b0557aeafa10aa1ffa1d7c87087a6149e',
              rawAmount: '9067814698',
              decimal: 18,
              amount: '0.000000009067814698',
              logo: 'https://api.rango.exchange/i/gyHe7C',
              usdPrice: null,
            },
            {
              chain: 'BOBA',
              symbol: 'BDOGE',
              ticker: 'BDOGE',
              address: '0x121636c43e96d97ab00b6c6994cddebef27de1c7',
              rawAmount: '723068225237233960',
              decimal: 18,
              amount: '0.72306822523723396',
              logo: 'https://api.rango.exchange/i/U6UPsb',
              usdPrice: 1.64e-9,
            },
            {
              chain: 'BOBA',
              symbol: 'SHIBUI',
              ticker: 'SHIBUI',
              address: '0xf08ad7c3f6b1c6843ba027ad54ed8ddb6d71169b',
              rawAmount: '1827087060',
              decimal: 18,
              amount: '0.00000000182708706',
              logo: 'https://api.rango.exchange/i/Mwv1h9',
              usdPrice: 0.00631,
            },
            {
              chain: 'BOBA',
              symbol: 'USDC',
              ticker: 'USDC',
              address: '0x66a2a913e447d6b4bf33efbec43aaef87890fbbc',
              rawAmount: '11210692',
              decimal: 6,
              amount: '11.210692',
              logo: 'https://api.rango.exchange/i/ahp7BS',
              usdPrice: 0.993,
            },
            {
              chain: 'BOBA',
              symbol: 'BOBA',
              ticker: 'BOBA',
              address: '0xa18bf3994c0cc6e3b63ac420308e5383f53120d7',
              rawAmount: '1093312869',
              decimal: 18,
              amount: '0.000000001093312869',
              logo: 'https://api.rango.exchange/i/vWYKUH',
              usdPrice: 0.181,
            },
            {
              chain: 'BOBA',
              symbol: 'WETH',
              ticker: 'WETH',
              address: '0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000',
              rawAmount: '2606189668',
              decimal: 18,
              amount: '0.000000002606189668',
              logo: 'https://api.rango.exchange/i/fEyllw',
              usdPrice: 1197.276,
            },
            {
              chain: 'BOBA',
              symbol: 'DAI',
              ticker: 'DAI',
              address: '0xf74195bb8a5cf652411867c5c2c5b8c2a402be35',
              rawAmount: '2131602501374765414',
              decimal: 18,
              amount: '2.131602501374765414',
              logo: 'https://api.rango.exchange/i/U8PEdb',
              usdPrice: null,
            },
            {
              chain: 'BOBA',
              symbol: 'ETH',
              ticker: 'ETH',
              address: null,
              rawAmount: '884271636924027',
              decimal: 18,
              amount: '0.000884271636924027',
              logo: 'https://api.rango.exchange/i/MTyH5i',
              usdPrice: 1197.276,
            },
          ],
          loading: false,
          walletType: 'metamask',
          isConnected: false,
          error: false,
          explorerUrl:
            'https://bobascan.com//address/0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        },
      ],
    },
  ],
} as Wallet;

export const meta = {
  blockchains: {
    BSC: {
      name: 'BSC',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'BSC', symbol: 'BNB', address: null }],
      logo: 'https://api.rango.exchange/blockchains/binance.svg',
      displayName: 'BSC',
      shortName: 'BSC',
      sort: 1,
      color: '#F3BA2F',
      enabled: true,
      type: 'EVM',
      chainId: '0x38',
      info: {
        chainName: 'Binance Smart Chain Mainnet',
        nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
        rpcUrls: ['https://bsc-dataseed1.ninicoin.io'],
        blockExplorerUrls: ['https://bscscan.com'],
        addressUrl: 'https://bscscan.com/address/{wallet}',
        transactionUrl: 'https://bscscan.com/tx/{txHash}',
        tokenUrl: 'https://bscscan.com/token/{address}',
      },
    },
    POLYGON: {
      name: 'POLYGON',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'POLYGON', symbol: 'MATIC', address: null }],
      logo: 'https://api.rango.exchange/blockchains/polygon.svg',
      displayName: 'Polygon',
      shortName: 'Polygon',
      sort: 2,
      color: '#8247E5',
      enabled: true,
      type: 'EVM',
      chainId: '0x89',
      info: {
        chainName: 'Polygon Mainnet',
        nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
        rpcUrls: ['https://polygon-rpc.com'],
        blockExplorerUrls: ['https://polygonscan.com'],
        addressUrl: 'https://polygonscan.com/address/{wallet}',
        transactionUrl: 'https://polygonscan.com/tx/{txHash}',
        tokenUrl: 'https://polygonscan.com/token/{address}',
      },
    },
    ETH: {
      name: 'ETH',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'ETH', symbol: 'ETH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/ethereum.svg',
      displayName: 'Ethereum',
      shortName: 'ETH',
      sort: 3,
      color: '#ecf0f1',
      enabled: true,
      type: 'EVM',
      chainId: '0x1',
      info: {
        chainName: 'Ethereum Mainnet',
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://rpc.ankr.com/eth'],
        blockExplorerUrls: ['https://etherscan.io'],
        addressUrl: 'https://etherscan.io/address/{wallet}',
        transactionUrl: 'https://etherscan.io/tx/{txHash}',
        tokenUrl: 'https://etherscan.io/token/{address}',
      },
    },
    OSMOSIS: {
      name: 'OSMOSIS',
      defaultDecimals: 6,
      addressPatterns: ['^(osmo1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'OSMOSIS', symbol: 'OSMO', address: null }],
      logo: 'https://api.rango.exchange/blockchains/osmosis.svg',
      displayName: 'Osmosis',
      shortName: 'Osmosis',
      sort: 4,
      color: '#7901B4',
      enabled: true,
      type: 'COSMOS',
      chainId: 'osmosis-1',
      info: {
        experimental: false,
        rpc: 'https://rpc-osmosis.keplr.app',
        rest: 'https://lcd-osmosis.keplr.app',
        cosmostationLcdUrl: 'https://lcd-osmosis.cosmostation.io',
        cosmostationApiUrl: 'https://api-osmosis.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'osmosis',
        chainName: 'Osmosis',
        stakeCurrency: {
          coinDenom: 'OSMO',
          coinMinimalDenom: 'uosmo',
          coinDecimals: 6,
          coinGeckoId: 'pool:uosmo',
          coinImageUrl: '/tokens/blockchain/osmosis.svg',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'osmo',
          bech32PrefixAccPub: 'osmopub',
          bech32PrefixValAddr: 'osmovaloper',
          bech32PrefixValPub: 'osmovaloperpub',
          bech32PrefixConsAddr: 'osmovalcons',
          bech32PrefixConsPub: 'osmovalconspub',
        },
        currencies: [
          {
            coinDenom: 'OSMO',
            coinMinimalDenom: 'uosmo',
            coinDecimals: 6,
            coinGeckoId: 'pool:uosmo',
            coinImageUrl: '/tokens/blockchain/osmosis.svg',
          },
          {
            coinDenom: 'ION',
            coinMinimalDenom: 'uion',
            coinDecimals: 6,
            coinGeckoId: 'pool:uion',
            coinImageUrl: '/tokens/blockchain/ion.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'OSMO',
            coinMinimalDenom: 'uosmo',
            coinDecimals: 6,
            coinGeckoId: 'pool:uosmo',
            coinImageUrl: '/tokens/blockchain/osmosis.svg',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/osmosis/txs/{txHash}',
        gasPriceStep: { low: 0, average: 0.025, high: 0.04 },
        tokenUrl: 'https://www.mintscan.io/osmosis/assets/{address}',
      },
    },
    JUNO: {
      name: 'JUNO',
      defaultDecimals: 6,
      addressPatterns: ['^(juno1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'JUNO', symbol: 'JUNO', address: null }],
      logo: 'https://api.rango.exchange/blockchains/juno.svg',
      displayName: 'Juno',
      shortName: 'Juno',
      sort: 5,
      color: '#f0827d',
      enabled: true,
      type: 'COSMOS',
      chainId: 'juno-1',
      info: {
        experimental: false,
        rpc: 'https://rpc-juno.itastakers.com:443/',
        rest: 'https://lcd-juno.keplr.app',
        cosmostationLcdUrl: 'https://lcd-juno.cosmostation.io',
        cosmostationApiUrl: 'https://api-juno.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'juno',
        chainName: 'Juno',
        stakeCurrency: {
          coinDenom: 'JUNO',
          coinMinimalDenom: 'ujuno',
          coinDecimals: 6,
          coinGeckoId: 'juno-network',
          coinImageUrl: '/tokens/blockchain/JUNO.png',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'juno',
          bech32PrefixAccPub: 'junopub',
          bech32PrefixValAddr: 'junovaloper',
          bech32PrefixValPub: 'junovaloperpub',
          bech32PrefixConsAddr: 'junovalcons',
          bech32PrefixConsPub: 'junovalconspub',
        },
        currencies: [
          {
            coinDenom: 'JUNO',
            coinMinimalDenom: 'ujuno',
            coinDecimals: 6,
            coinGeckoId: 'juno-network',
            coinImageUrl: '/tokens/blockchain/JUNO.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'JUNO',
            coinMinimalDenom: 'ujuno',
            coinDecimals: 6,
            coinGeckoId: 'juno-network',
            coinImageUrl: '/tokens/blockchain/JUNO.png',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/juno/txs/{txHash}',
        gasPriceStep: { low: 0.001, average: 0.0025, high: 0.004 },
        tokenUrl: null,
      },
    },
    AVAX_CCHAIN: {
      name: 'AVAX_CCHAIN',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'AVAX_CCHAIN', symbol: 'AVAX', address: null }],
      logo: 'https://api.rango.exchange/blockchains/avax_cchain.svg',
      displayName: 'Avalanche',
      shortName: 'Avax',
      sort: 6,
      color: '#e84142',
      enabled: true,
      type: 'EVM',
      chainId: '0xa86a',
      info: {
        chainName: 'Avalanche C-Chain',
        nativeCurrency: { name: 'AVAX', symbol: 'AVAX', decimals: 18 },
        rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
        blockExplorerUrls: ['https://snowtrace.io'],
        addressUrl: 'https://snowtrace.io/address/{wallet}',
        transactionUrl: 'https://snowtrace.io/tx/{txHash}',
        tokenUrl: 'https://snowtrace.dev/token/{address}',
      },
    },
    ARBITRUM: {
      name: 'ARBITRUM',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'ARBITRUM', symbol: 'ETH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/arbitrum.svg',
      displayName: 'Arbitrum',
      shortName: 'Arbitrum',
      sort: 7,
      color: '#28a0f0',
      enabled: true,
      type: 'EVM',
      chainId: '0xa4b1',
      info: {
        chainName: 'Arbitrum One',
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://arb1.arbitrum.io/rpc'],
        blockExplorerUrls: ['https://arbiscan.io'],
        addressUrl: 'https://arbiscan.io/address/{wallet}',
        transactionUrl: 'https://arbiscan.io/tx/{txHash}',
        tokenUrl: 'https://arbiscan.io/token/{address}',
      },
    },
    COSMOS: {
      name: 'COSMOS',
      defaultDecimals: 6,
      addressPatterns: ['^(cosmos1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'COSMOS', symbol: 'ATOM', address: null }],
      logo: 'https://api.rango.exchange/blockchains/cosmos.svg',
      displayName: 'Cosmos',
      shortName: 'Cosmos',
      sort: 8,
      color: '#2E3148',
      enabled: true,
      type: 'COSMOS',
      chainId: 'cosmoshub-4',
      info: {
        experimental: false,
        rpc: 'https://cosmos-rpc.polkachu.com',
        rest: 'https://lcd-cosmoshub.keplr.app',
        cosmostationLcdUrl: 'https://lcd-cosmos.cosmostation.io',
        cosmostationApiUrl: 'https://api-cosmos.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'cosmos',
        chainName: 'Cosmos',
        stakeCurrency: {
          coinDenom: 'ATOM',
          coinMinimalDenom: 'uatom',
          coinDecimals: 6,
          coinGeckoId: 'cosmos',
          coinImageUrl: '/tokens/blockchain/cosmos.svg',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'cosmos',
          bech32PrefixAccPub: 'cosmospub',
          bech32PrefixValAddr: 'cosmosvaloper',
          bech32PrefixValPub: 'cosmosvaloperpub',
          bech32PrefixConsAddr: 'cosmosvalcons',
          bech32PrefixConsPub: 'cosmosvalconspub',
        },
        currencies: [
          {
            coinDenom: 'ATOM',
            coinMinimalDenom: 'uatom',
            coinDecimals: 6,
            coinGeckoId: 'cosmos',
            coinImageUrl: '/tokens/blockchain/cosmos.svg',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'ATOM',
            coinMinimalDenom: 'uatom',
            coinDecimals: 6,
            coinGeckoId: 'cosmos',
            coinImageUrl: '/tokens/blockchain/cosmos.svg',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/cosmos/txs/{txHash}',
        gasPriceStep: { low: 0.01, average: 0.025, high: 0.04 },
        tokenUrl: 'https://www.mintscan.io/cosmos/assets/{address}',
      },
    },
    STARKNET: {
      name: 'STARKNET',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{64}$'],
      feeAssets: [
        {
          blockchain: 'STARKNET',
          symbol: 'ETH',
          address:
            '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
        },
      ],
      logo: 'https://api.rango.exchange/blockchains/starknet.svg',
      displayName: 'StarkNet',
      shortName: 'StarkNet',
      sort: 8,
      color: '#28286E',
      enabled: true,
      type: 'ZK_ROLLUP',
      chainId: 'SN_MAIN',
      info: null,
    },
    FANTOM: {
      name: 'FANTOM',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'FANTOM', symbol: 'FTM', address: null }],
      logo: 'https://api.rango.exchange/blockchains/fantom.png',
      displayName: 'Fantom',
      shortName: 'Fantom',
      sort: 9,
      color: '#337afe',
      enabled: true,
      type: 'EVM',
      chainId: '0xfa',
      info: {
        chainName: 'Fantom Opera',
        nativeCurrency: { name: 'FTM', symbol: 'FTM', decimals: 18 },
        rpcUrls: ['https://rpc.ftm.tools'],
        blockExplorerUrls: ['https://ftmscan.com'],
        addressUrl: 'https://ftmscan.com/address/{wallet}',
        transactionUrl: 'https://ftmscan.com/tx/{txHash}',
        tokenUrl: 'https://explorer.fantom.network/token/{address}',
      },
    },
    OPTIMISM: {
      name: 'OPTIMISM',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'OPTIMISM', symbol: 'ETH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/optimism.svg',
      displayName: 'Optimism',
      shortName: 'Optimism',
      sort: 10,
      color: '#FF0420',
      enabled: true,
      type: 'EVM',
      chainId: '0xa',
      info: {
        chainName: 'Optimism',
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://mainnet.optimism.io'],
        blockExplorerUrls: ['https://optimistic.etherscan.io'],
        addressUrl: 'https://optimistic.etherscan.io/address/{wallet}',
        transactionUrl: 'https://optimistic.etherscan.io/tx/{txHash}',
        tokenUrl: 'https://optimistic.etherscan.io/token/{address}',
      },
    },
    SOLANA: {
      name: 'SOLANA',
      defaultDecimals: 9,
      addressPatterns: ['^[1-9A-HJ-NP-Za-km-z]{32,44}$'],
      feeAssets: [{ blockchain: 'SOLANA', symbol: 'SOL', address: null }],
      logo: 'https://api.rango.exchange/blockchains/solana.svg',
      displayName: 'Solana',
      shortName: 'Solana',
      sort: 11,
      color: '#708DD2',
      enabled: true,
      type: 'SOLANA',
      chainId: 'mainnet-beta',
      info: null,
    },
    OKC: {
      name: 'OKC',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'OKC', symbol: 'OKT', address: null }],
      logo: 'https://api.rango.exchange/blockchains/okx.png',
      displayName: 'OKX Chain (OKC)',
      shortName: 'Okx',
      sort: 11,
      color: '#29a0f0',
      enabled: true,
      type: 'EVM',
      chainId: '0x42',
      info: {
        chainName: 'OKX Chain',
        nativeCurrency: { name: 'OKT', symbol: 'OKT', decimals: 18 },
        rpcUrls: ['https://exchainrpc.okex.org'],
        blockExplorerUrls: ['https://www.oklink.com/en/okc'],
        addressUrl: 'https://www.oklink.com/en/okc/address/{wallet}',
        transactionUrl: 'https://www.oklink.com/en/okc/tx/{txHash}',
        tokenUrl: null,
      },
    },
    CRONOS: {
      name: 'CRONOS',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'CRONOS', symbol: 'CRO', address: null }],
      logo: 'https://api.rango.exchange/blockchains/cronos.svg',
      displayName: 'Cronos',
      shortName: 'Cronos',
      sort: 12,
      color: '#1a90ff',
      enabled: true,
      type: 'EVM',
      chainId: '0x19',
      info: {
        chainName: 'Cronos Mainnet Beta',
        nativeCurrency: { name: 'CRO', symbol: 'CRO', decimals: 18 },
        rpcUrls: ['https://cronosrpc-1.xstaking.sg'],
        blockExplorerUrls: ['https://cronoscan.com'],
        addressUrl: 'https://cronoscan.com/address/{wallet}',
        transactionUrl: 'https://cronoscan.com/tx/{txHash}',
        tokenUrl: 'https://cronoscan.com/token/{address}',
      },
    },
    MOONRIVER: {
      name: 'MOONRIVER',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'MOONRIVER', symbol: 'MOVR', address: null }],
      logo: 'https://api.rango.exchange/blockchains/moonriver.svg',
      displayName: 'MoonRiver',
      shortName: 'MoonRiver',
      sort: 13,
      color: '#F3B404',
      enabled: true,
      type: 'EVM',
      chainId: '0x505',
      info: {
        chainName: 'MoonRiver',
        nativeCurrency: { name: 'MOVR', symbol: 'MOVR', decimals: 18 },
        rpcUrls: ['https://rpc.moonriver.moonbeam.network'],
        blockExplorerUrls: ['https://moonriver.moonscan.io'],
        addressUrl: 'https://moonriver.moonscan.io/address/{wallet}',
        transactionUrl: 'https://moonriver.moonscan.io/tx/{txHash}',
        tokenUrl: null,
      },
    },
    MOONBEAM: {
      name: 'MOONBEAM',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'MOONBEAM', symbol: 'GLMR', address: null }],
      logo: 'https://api.rango.exchange/blockchains/moonbeam.png',
      displayName: 'MoonBeam',
      shortName: 'MoonBeam',
      sort: 14,
      color: '#B3206B',
      enabled: true,
      type: 'EVM',
      chainId: '0x504',
      info: {
        chainName: 'MoonBeam',
        nativeCurrency: { name: 'GLMR', symbol: 'GLMR', decimals: 18 },
        rpcUrls: ['https://rpc.api.moonbeam.network'],
        blockExplorerUrls: ['https://moonbeam.moonscan.io'],
        addressUrl: 'https://moonbeam.moonscan.io/address/{wallet}',
        transactionUrl: 'https://moonbeam.moonscan.io/tx/{txHash}',
        tokenUrl: null,
      },
    },
    HECO: {
      name: 'HECO',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'HECO', symbol: 'HT', address: null }],
      logo: 'https://api.rango.exchange/blockchains/heco.png',
      displayName: 'Heco',
      shortName: 'Heco',
      sort: 15,
      color: '#4CA852',
      enabled: true,
      type: 'EVM',
      chainId: '0x80',
      info: {
        chainName: 'Huobi ECO Chain Mainnet',
        nativeCurrency: { name: 'HT', symbol: 'HT', decimals: 18 },
        rpcUrls: ['https://http-mainnet.hecochain.com'],
        blockExplorerUrls: ['https://hecoinfo.com'],
        addressUrl: 'https://hecoinfo.com/address/{wallet}',
        transactionUrl: 'https://hecoinfo.com/tx/{txHash}',
        tokenUrl: null,
      },
    },
    AURORA: {
      name: 'AURORA',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'AURORA', symbol: 'ETH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/aurora.svg',
      displayName: 'Aurora',
      shortName: 'Aurora',
      sort: 15,
      color: '#78d64b',
      enabled: true,
      type: 'EVM',
      chainId: '0x4e454152',
      info: {
        chainName: 'Aurora Mainnet',
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://mainnet.aurora.dev'],
        blockExplorerUrls: ['https://explorer.mainnet.aurora.dev'],
        addressUrl: 'https://explorer.mainnet.aurora.dev/address/{wallet}',
        transactionUrl: 'https://explorer.mainnet.aurora.dev/tx/{txHash}',
        tokenUrl: 'https://explorer.mainnet.aurora.dev/token/{address}',
      },
    },
    HARMONY: {
      name: 'HARMONY',
      defaultDecimals: 18,
      addressPatterns: ['^(one1)[0-9a-z]{38}$', '^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'HARMONY', symbol: 'ONE', address: null }],
      logo: 'https://api.rango.exchange/blockchains/harmony.svg',
      displayName: 'Harmony',
      shortName: 'Harmony',
      sort: 15,
      color: '#50AEE9',
      enabled: true,
      type: 'EVM',
      chainId: '0x63564c40',
      info: {
        chainName: 'Harmony Mainnet',
        nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
        rpcUrls: ['https://api.s0.t.hmny.io'],
        blockExplorerUrls: ['https://explorer.harmony.one'],
        addressUrl: 'https://explorer.harmony.one/address/{wallet}',
        transactionUrl: 'https://explorer.harmony.one/tx/{txHash}',
        tokenUrl: null,
      },
    },
    EVMOS: {
      name: 'EVMOS',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'EVMOS', symbol: 'EVMOS', address: null }],
      logo: 'https://api.rango.exchange/blockchains/evmos.png',
      displayName: 'Evmos',
      shortName: 'Evmos',
      sort: 15,
      color: '#2D2925',
      enabled: true,
      type: 'EVM',
      chainId: '0x2329',
      info: {
        chainName: 'Evmos',
        nativeCurrency: { name: 'EVMOS', symbol: 'EVMOS', decimals: 18 },
        rpcUrls: ['https://eth.bd.evmos.org:8545'],
        blockExplorerUrls: ['https://evm.evmos.org'],
        addressUrl: 'https://evm.evmos.org/address/{wallet}',
        transactionUrl: 'https://evm.evmos.org/tx/{txHash}',
        tokenUrl: null,
      },
    },
    SIF: {
      name: 'SIF',
      defaultDecimals: 18,
      addressPatterns: ['^(sif1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'SIF', symbol: 'ROWAN', address: null }],
      logo: 'https://api.rango.exchange/blockchains/sif.png',
      displayName: 'Sifchain',
      shortName: 'Sifchain',
      sort: 16,
      color: '#CAAA3A',
      enabled: true,
      type: 'COSMOS',
      chainId: 'sifchain-1',
      info: {
        experimental: false,
        rpc: 'https://rpc.sifchain.finance',
        rest: 'https://api-int.sifchain.finance',
        cosmostationLcdUrl: 'https://lcd-sifchain.cosmostation.io',
        cosmostationApiUrl: 'https://api-sifchain.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'sifchain',
        chainName: 'Sifchain',
        stakeCurrency: {
          coinDenom: 'ROWAN',
          coinMinimalDenom: 'rowan',
          coinDecimals: 18,
          coinGeckoId: '',
          coinImageUrl: '',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'sif',
          bech32PrefixAccPub: 'sifpub',
          bech32PrefixValAddr: 'sifvaloper',
          bech32PrefixValPub: 'sifvaloperpub',
          bech32PrefixConsAddr: 'sifvalcons',
          bech32PrefixConsPub: 'sifvalconspub',
        },
        currencies: [
          {
            coinDenom: 'ROWAN',
            coinMinimalDenom: 'rowan',
            coinDecimals: 18,
            coinGeckoId: '',
            coinImageUrl: '',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'ROWAN',
            coinMinimalDenom: 'rowan',
            coinDecimals: 18,
            coinGeckoId: '',
            coinImageUrl: '',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/sifchain/txs/{txHash}',
        gasPriceStep: {
          low: 1000000000000,
          average: 1500000000000,
          high: 2000000000000,
        },
        tokenUrl: null,
      },
    },
    THOR: {
      name: 'THOR',
      defaultDecimals: 8,
      addressPatterns: ['^(thor1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'THOR', symbol: 'RUNE', address: null }],
      logo: 'https://api.rango.exchange/blockchains/thorchain.svg',
      displayName: 'Thorchain',
      shortName: 'Thorchain',
      sort: 17,
      color: '#1AE6CB',
      enabled: true,
      type: 'TRANSFER',
      chainId: null,
      info: null,
    },
    BNB: {
      name: 'BNB',
      defaultDecimals: 8,
      addressPatterns: ['^(bnb1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'BNB', symbol: 'BNB', address: null }],
      logo: 'https://api.rango.exchange/blockchains/bnb.svg',
      displayName: 'Binance Chain',
      shortName: 'BNB',
      sort: 18,
      color: '#F3BA2F',
      enabled: true,
      type: 'COSMOS',
      chainId: null,
      info: null,
    },
    STARGAZE: {
      name: 'STARGAZE',
      defaultDecimals: 6,
      addressPatterns: ['^(stars1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'STARGAZE', symbol: 'STARS', address: null }],
      logo: 'https://api.rango.exchange/blockchains/stargaze.png',
      displayName: 'Stargaze',
      shortName: 'Stargaze',
      sort: 19,
      color: '#231B60',
      enabled: true,
      type: 'COSMOS',
      chainId: 'stargaze-1',
      info: {
        experimental: false,
        rpc: 'https://rpc.stargaze-apis.com',
        rest: 'https://rest.stargaze-apis.com',
        cosmostationLcdUrl: 'https://lcd-stargaze.cosmostation.io',
        cosmostationApiUrl: 'https://api-stargaze.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'stargaze',
        chainName: 'Stargaze',
        stakeCurrency: {
          coinDenom: 'STARS',
          coinMinimalDenom: 'ustars',
          coinDecimals: 6,
          coinGeckoId: 'pool:ustars',
          coinImageUrl: '/tokens/blockchain/STARS.png',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'stars',
          bech32PrefixAccPub: 'starspub',
          bech32PrefixValAddr: 'starsvaloper',
          bech32PrefixValPub: 'starsvaloperpub',
          bech32PrefixConsAddr: 'starsvalcons',
          bech32PrefixConsPub: 'starsvalconspub',
        },
        currencies: [
          {
            coinDenom: 'STARS',
            coinMinimalDenom: 'ustars',
            coinDecimals: 6,
            coinGeckoId: 'pool:ustars',
            coinImageUrl: '/tokens/blockchain/STARS.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'STARS',
            coinMinimalDenom: 'ustars',
            coinDecimals: 6,
            coinGeckoId: 'pool:ustars',
            coinImageUrl: '/tokens/blockchain/STARS.png',
          },
        ],
        features: ['stargate', 'ibc-transfer', 'no-legacy-stdTx'],
        explorerUrlToTx: 'https://www.mintscan.io/stargaze/txs/{txHash}',
        gasPriceStep: { low: 1, average: 1, high: 1 },
        tokenUrl: null,
      },
    },
    BTC: {
      name: 'BTC',
      defaultDecimals: 8,
      addressPatterns: [
        '^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^(bc1)[0-9A-Za-z]{39,59}$',
      ],
      feeAssets: [{ blockchain: 'BTC', symbol: 'BTC', address: null }],
      logo: 'https://api.rango.exchange/blockchains/btc.svg',
      displayName: 'Bitcoin',
      shortName: 'BTC',
      sort: 20,
      color: '#F7931A',
      enabled: true,
      type: 'TRANSFER',
      chainId: null,
      info: null,
    },
    CRYPTO_ORG: {
      name: 'CRYPTO_ORG',
      defaultDecimals: 8,
      addressPatterns: ['^(cro1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'CRYPTO_ORG', symbol: 'CRO', address: null }],
      logo: 'https://api.rango.exchange/blockchains/crypto_org.png',
      displayName: 'Crypto.org',
      shortName: 'Crypto.org',
      sort: 21,
      color: '#103F68',
      enabled: true,
      type: 'COSMOS',
      chainId: 'crypto-org-chain-mainnet-1',
      info: {
        experimental: false,
        rpc: 'https://rpc-crypto-org.keplr.app',
        rest: 'https://lcd-crypto-org.keplr.app',
        cosmostationLcdUrl: 'https://lcd-cryptocom.cosmostation.io',
        cosmostationApiUrl: 'https://api-cryptocom.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'crypto-org',
        chainName: 'Crypto.org',
        stakeCurrency: {
          coinDenom: 'CRO',
          coinMinimalDenom: 'basecro',
          coinDecimals: 8,
          coinGeckoId: 'crypto-com-chain',
          coinImageUrl: '/tokens/blockchain/cro.png',
        },
        bip44: { coinType: 394 },
        bech32Config: {
          bech32PrefixAccAddr: 'cro',
          bech32PrefixAccPub: 'cropub',
          bech32PrefixValAddr: 'crovaloper',
          bech32PrefixValPub: 'crovaloperpub',
          bech32PrefixConsAddr: 'crovalcons',
          bech32PrefixConsPub: 'crovalconspub',
        },
        currencies: [
          {
            coinDenom: 'CRO',
            coinMinimalDenom: 'basecro',
            coinDecimals: 8,
            coinGeckoId: 'crypto-com-chain',
            coinImageUrl: '/tokens/blockchain/cro.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'CRO',
            coinMinimalDenom: 'basecro',
            coinDecimals: 8,
            coinGeckoId: 'crypto-com-chain',
            coinImageUrl: '/tokens/blockchain/cro.png',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/crypto-org/txs/{txHash}',
        gasPriceStep: { low: 0.025, average: 0.03, high: 0.04 },
        tokenUrl: null,
      },
    },
    CHIHUAHUA: {
      name: 'CHIHUAHUA',
      defaultDecimals: 6,
      addressPatterns: ['^(chihuahua1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'CHIHUAHUA', symbol: 'HUAHUA', address: null }],
      logo: 'https://api.rango.exchange/blockchains/chihuahua.png',
      displayName: 'Chihuahua',
      shortName: 'Chihuahua',
      sort: 22,
      color: '#EFC92B',
      enabled: true,
      type: 'COSMOS',
      chainId: 'chihuahua-1',
      info: {
        experimental: true,
        rpc: 'https://rpc.chihuahua.wtf/',
        rest: 'https://api.chihuahua.wtf/',
        cosmostationLcdUrl: 'https://lcd-chihuahua.cosmostation.io',
        cosmostationApiUrl: 'https://api-chihuahua.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'chihuahua',
        chainName: 'Chihuahua',
        stakeCurrency: {
          coinDenom: 'HUAHUA',
          coinMinimalDenom: 'uhuahua',
          coinDecimals: 6,
          coinGeckoId: 'pool:uhuahua',
          coinImageUrl: '/tokens/blockchain/HUAHUA.svg',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'chihuahua',
          bech32PrefixAccPub: 'chihuahuapub',
          bech32PrefixValAddr: 'chihuahuavaloper',
          bech32PrefixValPub: 'chihuahuavaloperpub',
          bech32PrefixConsAddr: 'chihuahuavalcons',
          bech32PrefixConsPub: 'chihuahuavalconspub',
        },
        currencies: [
          {
            coinDenom: 'HUAHUA',
            coinMinimalDenom: 'uhuahua',
            coinDecimals: 6,
            coinGeckoId: 'pool:uhuahua',
            coinImageUrl: '/tokens/blockchain/HUAHUA.svg',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'HUAHUA',
            coinMinimalDenom: 'uhuahua',
            coinDecimals: 6,
            coinGeckoId: 'pool:uhuahua',
            coinImageUrl: '/tokens/blockchain/HUAHUA.svg',
          },
        ],
        features: ['stargate', 'ibc-transfer', 'no-legacy-stdTx'],
        explorerUrlToTx: 'https://ping.pub/chihuahua/tx/{txHash}',
        gasPriceStep: { low: 0.025, average: 0.03, high: 0.035 },
        tokenUrl: null,
      },
    },
    BANDCHAIN: {
      name: 'BANDCHAIN',
      defaultDecimals: 6,
      addressPatterns: ['^(band1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'BANDCHAIN', symbol: 'BAND', address: null }],
      logo: 'https://api.rango.exchange/blockchains/bandchain.svg',
      displayName: 'BandChain',
      shortName: 'BandChain',
      sort: 23,
      color: '#4520E6',
      enabled: true,
      type: 'COSMOS',
      chainId: 'laozi-mainnet',
      info: {
        experimental: true,
        rpc: 'https://rpc.laozi3.bandchain.org/',
        rest: 'https://lcd-band.cosmostation.io',
        cosmostationLcdUrl: 'https://lcd-band.cosmostation.io',
        cosmostationApiUrl: 'https://api-band.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'band',
        chainName: 'BandChain',
        stakeCurrency: {
          coinDenom: 'BAND',
          coinMinimalDenom: 'uband',
          coinDecimals: 6,
          coinGeckoId: 'band-protocol',
          coinImageUrl: '/tokens/blockchain/BAND.svg',
        },
        bip44: { coinType: 494 },
        bech32Config: {
          bech32PrefixAccAddr: 'band',
          bech32PrefixAccPub: 'bandpub',
          bech32PrefixValAddr: 'bandvaloper',
          bech32PrefixValPub: 'bandvaloperpub',
          bech32PrefixConsAddr: 'bandvalcons',
          bech32PrefixConsPub: 'bandvalconspub',
        },
        currencies: [
          {
            coinDenom: 'BAND',
            coinMinimalDenom: 'uband',
            coinDecimals: 6,
            coinGeckoId: 'band-protocol',
            coinImageUrl: '/tokens/blockchain/BAND.svg',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'BAND',
            coinMinimalDenom: 'uband',
            coinDecimals: 6,
            coinGeckoId: 'band-protocol',
            coinImageUrl: '/tokens/blockchain/BAND.svg',
          },
        ],
        features: ['stargate', 'ibc-transfer', 'no-legacy-stdTx'],
        explorerUrlToTx: 'https://cosmoscan.io/tx/{txHash}',
        gasPriceStep: null,
        tokenUrl: null,
      },
    },
    COMDEX: {
      name: 'COMDEX',
      defaultDecimals: 6,
      addressPatterns: ['^(comdex1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'COMDEX', symbol: 'CMDX', address: null }],
      logo: 'https://api.rango.exchange/blockchains/comdex.svg',
      displayName: 'Comdex',
      shortName: 'Comdex',
      sort: 23,
      color: '#FE4350',
      enabled: true,
      type: 'COSMOS',
      chainId: 'comdex-1',
      info: {
        experimental: true,
        rpc: 'https://rpc.comdex.one',
        rest: 'https://rest.comdex.one',
        cosmostationLcdUrl: 'https://lcd-comdex.cosmostation.io',
        cosmostationApiUrl: 'https://api-comdex.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'comdex',
        chainName: 'Comdex',
        stakeCurrency: {
          coinDenom: 'CMDX',
          coinMinimalDenom: 'ucmdx',
          coinDecimals: 6,
          coinGeckoId: 'comdex',
          coinImageUrl: '/tokens/blockchain/CMDX.png',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'comdex',
          bech32PrefixAccPub: 'comdexpub',
          bech32PrefixValAddr: 'comdexvaloper',
          bech32PrefixValPub: 'comdexvaloperpub',
          bech32PrefixConsAddr: 'comdexvalcons',
          bech32PrefixConsPub: 'comdexvalconspub',
        },
        currencies: [
          {
            coinDenom: 'CMDX',
            coinMinimalDenom: 'ucmdx',
            coinDecimals: 6,
            coinGeckoId: 'comdex',
            coinImageUrl: '/tokens/blockchain/CMDX.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'CMDX',
            coinMinimalDenom: 'ucmdx',
            coinDecimals: 6,
            coinGeckoId: 'comdex',
            coinImageUrl: '/tokens/blockchain/CMDX.png',
          },
        ],
        features: ['stargate', 'ibc-transfer', 'no-legacy-stdTx'],
        explorerUrlToTx: 'https://www.mintscan.io/comdex/txs/{txHash}',
        gasPriceStep: null,
        tokenUrl: null,
      },
    },
    REGEN: {
      name: 'REGEN',
      defaultDecimals: 6,
      addressPatterns: ['^(regen1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'REGEN', symbol: 'REGEN', address: null }],
      logo: 'https://api.rango.exchange/blockchains/regen.png',
      displayName: 'Regen Network',
      shortName: 'Regen Network',
      sort: 24,
      color: '#4FB573',
      enabled: true,
      type: 'COSMOS',
      chainId: 'regen-1',
      info: {
        experimental: false,
        rpc: 'https://rpc-regen.keplr.app',
        rest: 'https://lcd-regen.keplr.app',
        cosmostationLcdUrl: 'https://lcd-regen.keplr.app',
        cosmostationApiUrl: 'https://api-regen.cosmostation.io/',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'regen',
        chainName: 'Regen Network',
        stakeCurrency: {
          coinDenom: 'REGEN',
          coinMinimalDenom: 'uregen',
          coinDecimals: 6,
          coinGeckoId: 'pool:uregen',
          coinImageUrl: '/tokens/blockchain/regen.png',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'regen',
          bech32PrefixAccPub: 'regenpub',
          bech32PrefixValAddr: 'regenvaloper',
          bech32PrefixValPub: 'regenvaloperpub',
          bech32PrefixConsAddr: 'regenvalcons',
          bech32PrefixConsPub: 'regenvalconspub',
        },
        currencies: [
          {
            coinDenom: 'REGEN',
            coinMinimalDenom: 'uregen',
            coinDecimals: 6,
            coinGeckoId: 'pool:uregen',
            coinImageUrl: '/tokens/blockchain/regen.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'REGEN',
            coinMinimalDenom: 'uregen',
            coinDecimals: 6,
            coinGeckoId: 'pool:uregen',
            coinImageUrl: '/tokens/blockchain/regen.png',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://regen.aneka.io/txs/{txHash}',
        gasPriceStep: { low: 0.015, average: 0.025, high: 0.04 },
        tokenUrl: null,
      },
    },
    IRIS: {
      name: 'IRIS',
      defaultDecimals: 6,
      addressPatterns: ['^(iaa1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'IRIS', symbol: 'IRIS', address: null }],
      logo: 'https://api.rango.exchange/blockchains/iris.png',
      displayName: 'IRISnet',
      shortName: 'IRISnet',
      sort: 25,
      color: '#8A4A8E',
      enabled: true,
      type: 'COSMOS',
      chainId: 'irishub-1',
      info: {
        experimental: false,
        rpc: 'https://rpc-iris.keplr.app',
        rest: 'https://lcd-iris.keplr.app',
        cosmostationLcdUrl: 'https://lcd-iris.cosmostation.io',
        cosmostationApiUrl: 'https://api-iris.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'iris',
        chainName: 'IRISnet',
        stakeCurrency: {
          coinDenom: 'IRIS',
          coinMinimalDenom: 'uiris',
          coinDecimals: 6,
          coinGeckoId: 'iris-network',
          coinImageUrl: '/tokens/blockchain/iris.svg',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'iaa',
          bech32PrefixAccPub: 'iaapub',
          bech32PrefixValAddr: 'iaavaloper',
          bech32PrefixValPub: 'iaavaloperpub',
          bech32PrefixConsAddr: 'iaavalcons',
          bech32PrefixConsPub: 'iaavalconspub',
        },
        currencies: [
          {
            coinDenom: 'IRIS',
            coinMinimalDenom: 'uiris',
            coinDecimals: 6,
            coinGeckoId: 'iris-network',
            coinImageUrl: '/tokens/blockchain/iris.svg',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'IRIS',
            coinMinimalDenom: 'uiris',
            coinDecimals: 6,
            coinGeckoId: 'iris-network',
            coinImageUrl: '/tokens/blockchain/iris.svg',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/iris/txs/{txHash}',
        gasPriceStep: { low: 0.2, average: 0.3, high: 0.4 },
        tokenUrl: null,
      },
    },
    EMONEY: {
      name: 'EMONEY',
      defaultDecimals: 6,
      addressPatterns: ['^(emoney1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'EMONEY', symbol: 'NGM', address: null }],
      logo: 'https://api.rango.exchange/blockchains/emoney.svg',
      displayName: 'e-Money',
      shortName: 'e-Money',
      sort: 25,
      color: '#DFF5EF',
      enabled: true,
      type: 'COSMOS',
      chainId: 'emoney-3',
      info: {
        experimental: true,
        rpc: 'https://rpc-emoney.keplr.app',
        rest: 'https://lcd-emoney.keplr.app',
        cosmostationLcdUrl: 'https://lcd-emoney.cosmostation.io',
        cosmostationApiUrl: 'https://api-emoney.cosmostation.io',
        cosmostationDenomTracePath:
          '/ibc/applications/transfer/v1beta1/denom_traces/',
        mintScanName: 'emoney',
        chainName: 'e-Money',
        stakeCurrency: {
          coinDenom: 'NGM',
          coinMinimalDenom: 'ungm',
          coinDecimals: 6,
          coinGeckoId: 'e-money',
          coinImageUrl: '/tokens/blockchain/NGM.png',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'emoney',
          bech32PrefixAccPub: 'emoneypub',
          bech32PrefixValAddr: 'emoneyvaloper',
          bech32PrefixValPub: 'emoneyvaloperpub',
          bech32PrefixConsAddr: 'emoneyvalcons',
          bech32PrefixConsPub: 'emoneyvalconspub',
        },
        currencies: [
          {
            coinDenom: 'NGM',
            coinMinimalDenom: 'ungm',
            coinDecimals: 6,
            coinGeckoId: 'e-money',
            coinImageUrl: '/tokens/blockchain/NGM.png',
          },
          {
            coinDenom: 'EEUR',
            coinMinimalDenom: 'eeur',
            coinDecimals: 6,
            coinGeckoId: 'e-money-eur',
            coinImageUrl: '/tokens/blockchain/EEUR.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'NGM',
            coinMinimalDenom: 'ungm',
            coinDecimals: 6,
            coinGeckoId: 'e-money',
            coinImageUrl: '/tokens/blockchain/NGM.png',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://emoney.bigdipper.live/transactions/{txHash}',
        gasPriceStep: { low: 1, average: 1, high: 1 },
        tokenUrl: null,
      },
    },
    GNOSIS: {
      name: 'GNOSIS',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'GNOSIS', symbol: 'XDAI', address: null }],
      logo: 'https://api.rango.exchange/blockchains/gnosis.svg',
      displayName: 'Gnosis',
      shortName: 'Gnosis',
      sort: 26,
      color: '#3E6957',
      enabled: true,
      type: 'EVM',
      chainId: '0x64',
      info: {
        chainName: 'Gnosis Chain',
        nativeCurrency: { name: 'XDAI', symbol: 'XDAI', decimals: 18 },
        rpcUrls: ['https://rpc.gnosischain.com'],
        blockExplorerUrls: ['https://blockscout.com/xdai/mainnet'],
        addressUrl: 'https://blockscout.com/xdai/mainnet/address/{wallet}',
        transactionUrl: 'https://blockscout.com/xdai/mainnet/tx/{txHash}',
        tokenUrl: null,
      },
    },
    LTC: {
      name: 'LTC',
      defaultDecimals: 8,
      addressPatterns: ['^(L|M|3)[A-Za-z0-9]{33}$|^(ltc1)[0-9A-Za-z]{39}$'],
      feeAssets: [{ blockchain: 'LTC', symbol: 'LTC', address: null }],
      logo: 'https://api.rango.exchange/blockchains/ltc.svg',
      displayName: 'LiteCoin',
      shortName: 'LTC',
      sort: 27,
      color: '#345D9D',
      enabled: true,
      type: 'TRANSFER',
      chainId: null,
      info: null,
    },
    BCH: {
      name: 'BCH',
      defaultDecimals: 8,
      addressPatterns: [
        '^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^[0-9A-Za-z]{42,42}$',
      ],
      feeAssets: [{ blockchain: 'BCH', symbol: 'BCH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/bch.svg',
      displayName: 'Bitcoin Cash',
      shortName: 'BCH',
      sort: 28,
      color: '#0AC18E',
      enabled: true,
      type: 'TRANSFER',
      chainId: null,
      info: null,
    },
    FUSE: {
      name: 'FUSE',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'FUSE', symbol: 'FUSE', address: null }],
      logo: 'https://api.rango.exchange/blockchains/fuse.png',
      displayName: 'Fuse',
      shortName: 'Fuse',
      sort: 29,
      color: '#C5F9AD',
      enabled: true,
      type: 'EVM',
      chainId: '0x7a',
      info: {
        chainName: 'Fuse Mainnet',
        nativeCurrency: { name: 'FUSE', symbol: 'FUSE', decimals: 18 },
        rpcUrls: ['https://rpc.fuse.io'],
        blockExplorerUrls: ['https://explorer.fuse.io'],
        addressUrl: 'https://explorer.fuse.io/address/{wallet}',
        transactionUrl: 'https://explorer.fuse.io/tx/{txHash}',
        tokenUrl: null,
      },
    },
    AKASH: {
      name: 'AKASH',
      defaultDecimals: 6,
      addressPatterns: ['^(akash1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'AKASH', symbol: 'AKT', address: null }],
      logo: 'https://api.rango.exchange/blockchains/akash.svg',
      displayName: 'Akash',
      shortName: 'Akash',
      sort: 30,
      color: '#ED3524',
      enabled: true,
      type: 'COSMOS',
      chainId: 'akashnet-2',
      info: {
        experimental: false,
        rpc: 'https://rpc-akash.keplr.app',
        rest: 'https://lcd-akash.keplr.app',
        cosmostationLcdUrl: 'https://lcd-akash.cosmostation.io',
        cosmostationApiUrl: 'https://api-akash.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'akash',
        chainName: 'Akash',
        stakeCurrency: {
          coinDenom: 'AKT',
          coinMinimalDenom: 'uakt',
          coinDecimals: 6,
          coinGeckoId: 'akash-network',
          coinImageUrl: '/tokens/blockchain/akt.svg',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'akash',
          bech32PrefixAccPub: 'akashpub',
          bech32PrefixValAddr: 'akashvaloper',
          bech32PrefixValPub: 'akashvaloperpub',
          bech32PrefixConsAddr: 'akashvalcons',
          bech32PrefixConsPub: 'akashvalconspub',
        },
        currencies: [
          {
            coinDenom: 'AKT',
            coinMinimalDenom: 'uakt',
            coinDecimals: 6,
            coinGeckoId: 'akash-network',
            coinImageUrl: '/tokens/blockchain/akt.svg',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'AKT',
            coinMinimalDenom: 'uakt',
            coinDecimals: 6,
            coinGeckoId: 'akash-network',
            coinImageUrl: '/tokens/blockchain/akt.svg',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/akash/txs/{txHash}',
        gasPriceStep: { low: 0.001, average: 0.0025, high: 0.004 },
        tokenUrl: null,
      },
    },
    KI: {
      name: 'KI',
      defaultDecimals: 6,
      addressPatterns: ['^(ki1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'KI', symbol: 'XKI', address: null }],
      logo: 'https://api.rango.exchange/blockchains/ki.png',
      displayName: 'Ki',
      shortName: 'Ki',
      sort: 30,
      color: '#0F2B3D',
      enabled: true,
      type: 'COSMOS',
      chainId: 'kichain-2',
      info: {
        experimental: true,
        rpc: 'https://rpc-mainnet.blockchain.ki',
        rest: 'https://api-mainnet.blockchain.ki',
        cosmostationLcdUrl: 'https://lcd-kichain.cosmostation.io',
        cosmostationApiUrl: 'https://api-kichain.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'ki-chain',
        chainName: 'Ki',
        stakeCurrency: {
          coinDenom: 'XKI',
          coinMinimalDenom: 'uxki',
          coinDecimals: 6,
          coinGeckoId: 'pool:uxki',
          coinImageUrl: '/tokens/blockchain/XKI.png',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'ki',
          bech32PrefixAccPub: 'kipub',
          bech32PrefixValAddr: 'kivaloper',
          bech32PrefixValPub: 'kivaloperpub',
          bech32PrefixConsAddr: 'kivalcons',
          bech32PrefixConsPub: 'kivalconspub',
        },
        currencies: [
          {
            coinDenom: 'XKI',
            coinMinimalDenom: 'uxki',
            coinDecimals: 6,
            coinGeckoId: 'pool:uxki',
            coinImageUrl: '/tokens/blockchain/XKI.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'XKI',
            coinMinimalDenom: 'uxki',
            coinDecimals: 6,
            coinGeckoId: 'pool:uxki',
            coinImageUrl: '/tokens/blockchain/XKI.png',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/ki-chain/txs/{txHash}',
        gasPriceStep: null,
        tokenUrl: null,
      },
    },
    KUJIRA: {
      name: 'KUJIRA',
      defaultDecimals: 6,
      addressPatterns: ['^(kujira1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'KUJIRA', symbol: 'KUJI', address: null }],
      logo: 'https://api.rango.exchange/blockchains/kuji.svg',
      displayName: 'Kujira',
      shortName: 'Kujira',
      sort: 31,
      color: '#DF3935',
      enabled: true,
      type: 'COSMOS',
      chainId: 'kaiyo-1',
      info: {
        experimental: true,
        rpc: 'https://rpc.kaiyo.kujira.setten.io',
        rest: 'https://lcd.kaiyo.kujira.setten.io',
        cosmostationLcdUrl: 'https://lcd-kujira.cosmostation.io',
        cosmostationApiUrl: 'https://api-kujira.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'kujira',
        chainName: 'Kujira',
        stakeCurrency: {
          coinDenom: 'KUJI',
          coinMinimalDenom: 'ukuji',
          coinDecimals: 6,
          coinGeckoId: 'kujira',
          coinImageUrl: '/tokens/blockchain/kuji.svg',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'kujira',
          bech32PrefixAccPub: 'kujirapub',
          bech32PrefixValAddr: 'kujiravaloper',
          bech32PrefixValPub: 'kujiravaloperpub',
          bech32PrefixConsAddr: 'kujiravalcons',
          bech32PrefixConsPub: 'kujiravalconspub',
        },
        currencies: [
          {
            coinDenom: 'KUJI',
            coinMinimalDenom: 'ukuji',
            coinDecimals: 6,
            coinGeckoId: 'kujira',
            coinImageUrl: '/tokens/blockchain/kuji.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'KUJI',
            coinMinimalDenom: 'ukuji',
            coinDecimals: 6,
            coinGeckoId: 'kujira',
            coinImageUrl: '/tokens/blockchain/kuji.png',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://finder.kujira.app/kaiyo-1/tx/{txHash}',
        gasPriceStep: { low: 0.01, average: 0.025, high: 0.03 },
        tokenUrl: null,
      },
    },
    PERSISTENCE: {
      name: 'PERSISTENCE',
      defaultDecimals: 6,
      addressPatterns: ['^(persistence1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'PERSISTENCE', symbol: 'XPRT', address: null }],
      logo: 'https://api.rango.exchange/blockchains/persistence.png',
      displayName: 'Persistence',
      shortName: 'Persistence',
      sort: 31,
      color: '#383838',
      enabled: true,
      type: 'COSMOS',
      chainId: 'core-1',
      info: {
        experimental: false,
        rpc: 'https://rpc-persistence.keplr.app',
        rest: 'https://lcd-persistence.keplr.app',
        cosmostationLcdUrl: 'https://lcd-persistence.cosmostation.io',
        cosmostationApiUrl: 'https://api-persistence.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'persistence',
        chainName: 'Persistence',
        stakeCurrency: {
          coinDenom: 'XPRT',
          coinMinimalDenom: 'uxprt',
          coinDecimals: 6,
          coinGeckoId: 'persistence',
          coinImageUrl: '/tokens/blockchain/xprt.png',
        },
        bip44: { coinType: 750 },
        bech32Config: {
          bech32PrefixAccAddr: 'persistence',
          bech32PrefixAccPub: 'persistencepub',
          bech32PrefixValAddr: 'persistencevaloper',
          bech32PrefixValPub: 'persistencevaloperpub',
          bech32PrefixConsAddr: 'persistencevalcons',
          bech32PrefixConsPub: 'persistencevalconspub',
        },
        currencies: [
          {
            coinDenom: 'XPRT',
            coinMinimalDenom: 'uxprt',
            coinDecimals: 6,
            coinGeckoId: 'persistence',
            coinImageUrl: '/tokens/blockchain/xprt.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'XPRT',
            coinMinimalDenom: 'uxprt',
            coinDecimals: 6,
            coinGeckoId: 'persistence',
            coinImageUrl: '/tokens/blockchain/xprt.png',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/persistence/txs/{txHash}',
        gasPriceStep: { low: 0, average: 0.025, high: 0.04 },
        tokenUrl: null,
      },
    },
    SENTINEL: {
      name: 'SENTINEL',
      defaultDecimals: 6,
      addressPatterns: ['^(sent1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'SENTINEL', symbol: 'DVPN', address: null }],
      logo: 'https://api.rango.exchange/blockchains/sentinel.png',
      displayName: 'Sentinel',
      shortName: 'Sentinel',
      sort: 32,
      color: '#142E51',
      enabled: true,
      type: 'COSMOS',
      chainId: 'sentinelhub-2',
      info: {
        experimental: false,
        rpc: 'https://rpc-sentinel.keplr.app',
        rest: 'https://lcd-sentinel.keplr.app',
        cosmostationLcdUrl: 'https://lcd-sentinel.cosmostation.io',
        cosmostationApiUrl: 'https://api-sentinel.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'sentinel',
        chainName: 'Sentinel',
        stakeCurrency: {
          coinDenom: 'DVPN',
          coinMinimalDenom: 'udvpn',
          coinDecimals: 6,
          coinGeckoId: 'sentinel',
          coinImageUrl: '/tokens/blockchain/dvpn.png',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'sent',
          bech32PrefixAccPub: 'sentpub',
          bech32PrefixValAddr: 'sentvaloper',
          bech32PrefixValPub: 'sentvaloperpub',
          bech32PrefixConsAddr: 'sentvalcons',
          bech32PrefixConsPub: 'sentvalconspub',
        },
        currencies: [
          {
            coinDenom: 'DVPN',
            coinMinimalDenom: 'udvpn',
            coinDecimals: 6,
            coinGeckoId: 'sentinel',
            coinImageUrl: '/tokens/blockchain/dvpn.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'DVPN',
            coinMinimalDenom: 'udvpn',
            coinDecimals: 6,
            coinGeckoId: 'sentinel',
            coinImageUrl: '/tokens/blockchain/dvpn.png',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/sentinel/txs/{txHash}',
        gasPriceStep: { low: 0.1, average: 0.25, high: 0.4 },
        tokenUrl: null,
      },
    },
    STARNAME: {
      name: 'STARNAME',
      defaultDecimals: 6,
      addressPatterns: ['^(star1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'STARNAME', symbol: 'IOV', address: null }],
      logo: 'https://api.rango.exchange/blockchains/starname.png',
      displayName: 'Starname',
      shortName: 'Starname',
      sort: 35,
      color: '#BC64BB',
      enabled: true,
      type: 'COSMOS',
      chainId: 'iov-mainnet-ibc',
      info: {
        experimental: false,
        rpc: 'https://rpc-iov.keplr.app',
        rest: 'https://lcd-iov.keplr.app',
        cosmostationLcdUrl: 'https://lcd-iov.cosmostation.io',
        cosmostationApiUrl: 'https://api-iov.cosmostation.io',
        cosmostationDenomTracePath:
          '/ibc/applications/transfer/v1beta1/denom_traces/',
        mintScanName: 'starname',
        chainName: 'Starname',
        stakeCurrency: {
          coinDenom: 'IOV',
          coinMinimalDenom: 'uiov',
          coinDecimals: 6,
          coinGeckoId: 'starname',
          coinImageUrl: '/tokens/blockchain/IOV.png',
        },
        bip44: { coinType: 494 },
        bech32Config: {
          bech32PrefixAccAddr: 'star',
          bech32PrefixAccPub: 'starpub',
          bech32PrefixValAddr: 'starvaloper',
          bech32PrefixValPub: 'starvaloperpub',
          bech32PrefixConsAddr: 'starvalcons',
          bech32PrefixConsPub: 'starvalconspub',
        },
        currencies: [
          {
            coinDenom: 'IOV',
            coinMinimalDenom: 'uiov',
            coinDecimals: 6,
            coinGeckoId: 'starname',
            coinImageUrl: '/tokens/blockchain/IOV.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'IOV',
            coinMinimalDenom: 'uiov',
            coinDecimals: 6,
            coinGeckoId: 'starname',
            coinImageUrl: '/tokens/blockchain/IOV.png',
          },
        ],
        features: ['stargate', 'ibc-transfer'],
        explorerUrlToTx: 'https://www.mintscan.io/starname/txs/{txHash}',
        gasPriceStep: { low: 1, average: 2, high: 3 },
        tokenUrl: null,
      },
    },
    UMEE: {
      name: 'UMEE',
      defaultDecimals: 6,
      addressPatterns: ['^(umee1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'UMEE', symbol: 'UMEE', address: null }],
      logo: 'https://api.rango.exchange/blockchains/umee.svg',
      displayName: 'Umee',
      shortName: 'Umee',
      sort: 36,
      color: '#D2B6FF',
      enabled: true,
      type: 'COSMOS',
      chainId: 'umee-1',
      info: {
        experimental: false,
        rpc: 'https://api.barnacle.mainnet.network.umee.cc',
        rest: 'https://lcd-umee.cosmostation.io',
        cosmostationLcdUrl: 'https://lcd-umee.cosmostation.io',
        cosmostationApiUrl: 'https://api-umee.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'umee',
        chainName: 'Umee',
        stakeCurrency: {
          coinDenom: 'UMEE',
          coinMinimalDenom: 'uumee',
          coinDecimals: 6,
          coinGeckoId: 'pool:uumee',
          coinImageUrl: '/tokens/blockchain/UMEE.png',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'umee',
          bech32PrefixAccPub: 'umeepub',
          bech32PrefixValAddr: 'umeevaloper',
          bech32PrefixValPub: 'umeevaloperpub',
          bech32PrefixConsAddr: 'umeevalcons',
          bech32PrefixConsPub: 'umeevalconspub',
        },
        currencies: [
          {
            coinDenom: 'UMEE',
            coinMinimalDenom: 'uumee',
            coinDecimals: 6,
            coinGeckoId: 'pool:uumee',
            coinImageUrl: '/tokens/blockchain/UMEE.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'UMEE',
            coinMinimalDenom: 'uumee',
            coinDecimals: 6,
            coinGeckoId: 'pool:uumee',
            coinImageUrl: '/tokens/blockchain/UMEE.png',
          },
        ],
        features: ['stargate', 'ibc-transfer', 'no-legacy-stdTx'],
        explorerUrlToTx: 'https://www.mintscan.io/umee/txs/{txHash}',
        gasPriceStep: { low: 0.05, average: 0.06, high: 0.1 },
        tokenUrl: null,
      },
    },
    BITCANNA: {
      name: 'BITCANNA',
      defaultDecimals: 6,
      addressPatterns: ['^(bcna1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'BITCANNA', symbol: 'BCNA', address: null }],
      logo: 'https://api.rango.exchange/blockchains/bitcanna.svg',
      displayName: 'BitCanna',
      shortName: 'BitCanna',
      sort: 36,
      color: '#3CC194',
      enabled: true,
      type: 'COSMOS',
      chainId: 'bitcanna-1',
      info: {
        experimental: true,
        rpc: 'https://rpc.bitcanna.io',
        rest: 'https://lcd.bitcanna.io',
        cosmostationLcdUrl: 'https://lcd-bitcanna.cosmostation.io',
        cosmostationApiUrl: 'https://api-bitcanna.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'bitcanna',
        chainName: 'BitCanna',
        stakeCurrency: {
          coinDenom: 'BCNA',
          coinMinimalDenom: 'ubcna',
          coinDecimals: 6,
          coinGeckoId: 'bitcanna',
          coinImageUrl: '/tokens/blockchain/BCNA.png',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'bcna',
          bech32PrefixAccPub: 'bcnapub',
          bech32PrefixValAddr: 'bcnavaloper',
          bech32PrefixValPub: 'bcnavaloperpub',
          bech32PrefixConsAddr: 'bcnavalcons',
          bech32PrefixConsPub: 'bcnavalconspub',
        },
        currencies: [
          {
            coinDenom: 'BCNA',
            coinMinimalDenom: 'ubcna',
            coinDecimals: 6,
            coinGeckoId: 'bitcanna',
            coinImageUrl: '/tokens/blockchain/BCNA.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'BCNA',
            coinMinimalDenom: 'ubcna',
            coinDecimals: 6,
            coinGeckoId: 'bitcanna',
            coinImageUrl: '/tokens/blockchain/BCNA.png',
          },
        ],
        features: ['stargate', 'ibc-transfer', 'no-legacy-stdTx'],
        explorerUrlToTx: 'https://www.mintscan.io/bitcanna/txs/{txHash}',
        gasPriceStep: null,
        tokenUrl: null,
      },
    },
    DESMOS: {
      name: 'DESMOS',
      defaultDecimals: 6,
      addressPatterns: ['^(desmos1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'DESMOS', symbol: 'DSM', address: null }],
      logo: 'https://api.rango.exchange/blockchains/desmos.svg',
      displayName: 'Desmos',
      shortName: 'Desmos',
      sort: 37,
      color: '#DF6952',
      enabled: true,
      type: 'COSMOS',
      chainId: 'desmos-mainnet',
      info: {
        experimental: true,
        rpc: 'https://rpc.mainnet.desmos.network',
        rest: 'https://api.mainnet.desmos.network',
        cosmostationLcdUrl: 'https://lcd-desmos.cosmostation.io',
        cosmostationApiUrl: 'https://api-desmos.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'desmos',
        chainName: 'Desmos',
        stakeCurrency: {
          coinDenom: 'DSM',
          coinMinimalDenom: 'udsm',
          coinDecimals: 6,
          coinGeckoId: 'pool:udsm',
          coinImageUrl: '/tokens/blockchain/DSM.png',
        },
        bip44: { coinType: 852 },
        bech32Config: {
          bech32PrefixAccAddr: 'desmos',
          bech32PrefixAccPub: 'desmospub',
          bech32PrefixValAddr: 'desmosvaloper',
          bech32PrefixValPub: 'desmosvaloperpub',
          bech32PrefixConsAddr: 'desmosvalcons',
          bech32PrefixConsPub: 'desmosvalconspub',
        },
        currencies: [
          {
            coinDenom: 'DSM',
            coinMinimalDenom: 'udsm',
            coinDecimals: 6,
            coinGeckoId: 'pool:udsm',
            coinImageUrl: '/tokens/blockchain/DSM.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'DSM',
            coinMinimalDenom: 'udsm',
            coinDecimals: 6,
            coinGeckoId: 'pool:udsm',
            coinImageUrl: '/tokens/blockchain/DSM.png',
          },
        ],
        features: ['stargate', 'ibc-transfer', 'no-legacy-stdTx', 'ibc-go'],
        explorerUrlToTx:
          'https://explorer.desmos.network/transactions/{txHash}',
        gasPriceStep: null,
        tokenUrl: null,
      },
    },
    LUMNETWORK: {
      name: 'LUMNETWORK',
      defaultDecimals: 6,
      addressPatterns: ['^(lum1)[0-9a-z]{38}$'],
      feeAssets: [{ blockchain: 'LUMNETWORK', symbol: 'LUM', address: null }],
      logo: 'https://api.rango.exchange/blockchains/lumnetwork.svg',
      displayName: 'Lum Network',
      shortName: 'Lum Network',
      sort: 38,
      color: '#1B42B4',
      enabled: true,
      type: 'COSMOS',
      chainId: 'lum-network-1',
      info: {
        experimental: true,
        rpc: 'https://node0.mainnet.lum.network/rpc',
        rest: 'https://node0.mainnet.lum.network/rest',
        cosmostationLcdUrl: 'https://lcd-lum.cosmostation.io',
        cosmostationApiUrl: 'https://api-lum.cosmostation.io',
        cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
        mintScanName: 'lum',
        chainName: 'Lum Network',
        stakeCurrency: {
          coinDenom: 'LUM',
          coinMinimalDenom: 'ulum',
          coinDecimals: 6,
          coinGeckoId: 'pool:ulum',
          coinImageUrl: '/tokens/blockchain/LUM.png',
        },
        bip44: { coinType: 118 },
        bech32Config: {
          bech32PrefixAccAddr: 'lum',
          bech32PrefixAccPub: 'lumpub',
          bech32PrefixValAddr: 'lumvaloper',
          bech32PrefixValPub: 'lumvaloperpub',
          bech32PrefixConsAddr: 'lumvalcons',
          bech32PrefixConsPub: 'lumvalconspub',
        },
        currencies: [
          {
            coinDenom: 'LUM',
            coinMinimalDenom: 'ulum',
            coinDecimals: 6,
            coinGeckoId: 'pool:ulum',
            coinImageUrl: '/tokens/blockchain/LUM.png',
          },
        ],
        feeCurrencies: [
          {
            coinDenom: 'LUM',
            coinMinimalDenom: 'ulum',
            coinDecimals: 6,
            coinGeckoId: 'pool:ulum',
            coinImageUrl: '/tokens/blockchain/LUM.png',
          },
        ],
        features: ['stargate', 'ibc-transfer', 'no-legacy-stdTx', 'ibc-go'],
        explorerUrlToTx: 'https://www.mintscan.io/lum/txs/{txHash}',
        gasPriceStep: null,
        tokenUrl: null,
      },
    },
    BOBA: {
      name: 'BOBA',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'BOBA', symbol: 'ETH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/boba.png',
      displayName: 'Boba',
      shortName: 'Boba',
      sort: 39,
      color: '#ccff00',
      enabled: true,
      type: 'EVM',
      chainId: '0x120',
      info: {
        chainName: 'Boba Network',
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://mainnet.boba.network'],
        blockExplorerUrls: ['https://bobascan.com/'],
        addressUrl: 'https://bobascan.com//address/{wallet}',
        transactionUrl: 'https://bobascan.com//tx/{txHash}',
        tokenUrl: null,
      },
    },
  },
  evmNetworkChainInfo: {
    BSC: {
      chainName: 'Binance Smart Chain Mainnet',
      chainId: '0x38',
      nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
      rpcUrls: ['https://bsc-dataseed1.ninicoin.io'],
      blockExplorerUrls: ['https://bscscan.com'],
    },
    POLYGON: {
      chainName: 'Polygon Mainnet',
      chainId: '0x89',
      nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
      rpcUrls: ['https://polygon-rpc.com'],
      blockExplorerUrls: ['https://polygonscan.com'],
    },
    ETH: {
      chainName: 'Ethereum Mainnet',
      chainId: '0x1',
      nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://rpc.ankr.com/eth'],
      blockExplorerUrls: ['https://etherscan.io'],
    },
    AVAX_CCHAIN: {
      chainName: 'Avalanche C-Chain',
      chainId: '0xa86a',
      nativeCurrency: { name: 'AVAX', symbol: 'AVAX', decimals: 18 },
      rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
      blockExplorerUrls: ['https://snowtrace.io'],
    },
    ARBITRUM: {
      chainName: 'Arbitrum One',
      chainId: '0xa4b1',
      nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://arb1.arbitrum.io/rpc'],
      blockExplorerUrls: ['https://arbiscan.io'],
    },
    FANTOM: {
      chainName: 'Fantom Opera',
      chainId: '0xfa',
      nativeCurrency: { name: 'FTM', symbol: 'FTM', decimals: 18 },
      rpcUrls: ['https://rpc.ftm.tools'],
      blockExplorerUrls: ['https://ftmscan.com'],
    },
    OPTIMISM: {
      chainName: 'Optimism',
      chainId: '0xa',
      nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://mainnet.optimism.io'],
      blockExplorerUrls: ['https://optimistic.etherscan.io'],
    },
    OKC: {
      chainName: 'OKX Chain',
      chainId: '0x42',
      nativeCurrency: { name: 'OKT', symbol: 'OKT', decimals: 18 },
      rpcUrls: ['https://exchainrpc.okex.org'],
      blockExplorerUrls: ['https://www.oklink.com/en/okc'],
    },
    CRONOS: {
      chainName: 'Cronos Mainnet Beta',
      chainId: '0x19',
      nativeCurrency: { name: 'CRO', symbol: 'CRO', decimals: 18 },
      rpcUrls: ['https://cronosrpc-1.xstaking.sg'],
      blockExplorerUrls: ['https://cronoscan.com'],
    },
    MOONRIVER: {
      chainName: 'MoonRiver',
      chainId: '0x505',
      nativeCurrency: { name: 'MOVR', symbol: 'MOVR', decimals: 18 },
      rpcUrls: ['https://rpc.moonriver.moonbeam.network'],
      blockExplorerUrls: ['https://moonriver.moonscan.io'],
    },
    MOONBEAM: {
      chainName: 'MoonBeam',
      chainId: '0x504',
      nativeCurrency: { name: 'GLMR', symbol: 'GLMR', decimals: 18 },
      rpcUrls: ['https://rpc.api.moonbeam.network'],
      blockExplorerUrls: ['https://moonbeam.moonscan.io'],
    },
    HECO: {
      chainName: 'Huobi ECO Chain Mainnet',
      chainId: '0x80',
      nativeCurrency: { name: 'HT', symbol: 'HT', decimals: 18 },
      rpcUrls: ['https://http-mainnet.hecochain.com'],
      blockExplorerUrls: ['https://hecoinfo.com'],
    },
    AURORA: {
      chainName: 'Aurora Mainnet',
      chainId: '0x4e454152',
      nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://mainnet.aurora.dev'],
      blockExplorerUrls: ['https://explorer.mainnet.aurora.dev'],
    },
    HARMONY: {
      chainName: 'Harmony Mainnet',
      chainId: '0x63564c40',
      nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
      rpcUrls: ['https://api.s0.t.hmny.io'],
      blockExplorerUrls: ['https://explorer.harmony.one'],
    },
    EVMOS: {
      chainName: 'Evmos',
      chainId: '0x2329',
      nativeCurrency: { name: 'EVMOS', symbol: 'EVMOS', decimals: 18 },
      rpcUrls: ['https://eth.bd.evmos.org:8545'],
      blockExplorerUrls: ['https://evm.evmos.org'],
    },
    GNOSIS: {
      chainName: 'Gnosis Chain',
      chainId: '0x64',
      nativeCurrency: { name: 'XDAI', symbol: 'XDAI', decimals: 18 },
      rpcUrls: ['https://rpc.gnosischain.com'],
      blockExplorerUrls: ['https://blockscout.com/xdai/mainnet'],
    },
    FUSE: {
      chainName: 'Fuse Mainnet',
      chainId: '0x7a',
      nativeCurrency: { name: 'FUSE', symbol: 'FUSE', decimals: 18 },
      rpcUrls: ['https://rpc.fuse.io'],
      blockExplorerUrls: ['https://explorer.fuse.io'],
    },
    BOBA: {
      chainName: 'Boba Network',
      chainId: '0x120',
      nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://mainnet.boba.network'],
      blockExplorerUrls: ['https://bobascan.com/'],
    },
  },
  walletsAndSupportedChainsNames: {
    'binance-chain': ['BSC', 'ETH', 'BNB'],
    metamask: [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
    ],
    coinbase: [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
      'SOLANA',
    ],
    keplr: [
      'OSMOSIS',
      'JUNO',
      'COSMOS',
      'SIF',
      'STARGAZE',
      'CRYPTO_ORG',
      'CHIHUAHUA',
      'BANDCHAIN',
      'COMDEX',
      'REGEN',
      'IRIS',
      'EMONEY',
      'AKASH',
      'KI',
      'KUJIRA',
      'PERSISTENCE',
      'SENTINEL',
      'STARNAME',
      'UMEE',
      'BITCANNA',
      'DESMOS',
      'LUMNETWORK',
    ],
    phantom: ['SOLANA'],
    xdefi: [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'SOLANA',
      'THOR',
      'BNB',
      'BTC',
      'LTC',
      'BCH',
    ],
    'wallet-connect-2': [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
    ],
    'trust-wallet': [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
    ],
    coin98: [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
      'SOLANA',
    ],
    okx: [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'SOLANA',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HARMONY',
      'BTC',
      'GNOSIS',
      'LTC',
      'BOBA',
    ],
    exodus: ['BSC', 'POLYGON', 'ETH', 'AVAX_CCHAIN', 'SOLANA', 'BNB'],
    'token-pocket': [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
    ],
    'terra-station': [],
    leap: [],
    math: [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
      'SOLANA',
    ],
    safepal: [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
      'SOLANA',
    ],
    clover: [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
      'SOLANA',
    ],
    cosmostation: [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
      'OSMOSIS',
      'JUNO',
      'COSMOS',
      'SIF',
      'STARGAZE',
      'CRYPTO_ORG',
      'CHIHUAHUA',
      'BANDCHAIN',
      'COMDEX',
      'REGEN',
      'IRIS',
      'EMONEY',
      'AKASH',
      'KI',
      'KUJIRA',
      'PERSISTENCE',
      'SENTINEL',
      'STARNAME',
      'UMEE',
      'BITCANNA',
      'DESMOS',
      'LUMNETWORK',
    ],
    brave: [
      'BSC',
      'POLYGON',
      'ETH',
      'AVAX_CCHAIN',
      'ARBITRUM',
      'FANTOM',
      'OPTIMISM',
      'OKC',
      'CRONOS',
      'MOONRIVER',
      'MOONBEAM',
      'HECO',
      'AURORA',
      'HARMONY',
      'EVMOS',
      'GNOSIS',
      'FUSE',
      'BOBA',
      'SOLANA',
    ],
    unknown: [],
  },
  evmBasedChains: [
    {
      name: 'BSC',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'BSC', symbol: 'BNB', address: null }],
      logo: 'https://api.rango.exchange/blockchains/binance.svg',
      displayName: 'BSC',
      shortName: 'BSC',
      sort: 1,
      color: '#F3BA2F',
      enabled: true,
      type: 'EVM',
      chainId: '0x38',
      info: {
        chainName: 'Binance Smart Chain Mainnet',
        nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
        rpcUrls: ['https://bsc-dataseed1.ninicoin.io'],
        blockExplorerUrls: ['https://bscscan.com'],
        addressUrl: 'https://bscscan.com/address/{wallet}',
        transactionUrl: 'https://bscscan.com/tx/{txHash}',
        tokenUrl: 'https://bscscan.com/token/{address}',
      },
    },
    {
      name: 'POLYGON',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'POLYGON', symbol: 'MATIC', address: null }],
      logo: 'https://api.rango.exchange/blockchains/polygon.svg',
      displayName: 'Polygon',
      shortName: 'Polygon',
      sort: 2,
      color: '#8247E5',
      enabled: true,
      type: 'EVM',
      chainId: '0x89',
      info: {
        chainName: 'Polygon Mainnet',
        nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
        rpcUrls: ['https://polygon-rpc.com'],
        blockExplorerUrls: ['https://polygonscan.com'],
        addressUrl: 'https://polygonscan.com/address/{wallet}',
        transactionUrl: 'https://polygonscan.com/tx/{txHash}',
        tokenUrl: 'https://polygonscan.com/token/{address}',
      },
    },
    {
      name: 'ETH',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'ETH', symbol: 'ETH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/ethereum.svg',
      displayName: 'Ethereum',
      shortName: 'ETH',
      sort: 3,
      color: '#ecf0f1',
      enabled: true,
      type: 'EVM',
      chainId: '0x1',
      info: {
        chainName: 'Ethereum Mainnet',
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://rpc.ankr.com/eth'],
        blockExplorerUrls: ['https://etherscan.io'],
        addressUrl: 'https://etherscan.io/address/{wallet}',
        transactionUrl: 'https://etherscan.io/tx/{txHash}',
        tokenUrl: 'https://etherscan.io/token/{address}',
      },
    },
    {
      name: 'AVAX_CCHAIN',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'AVAX_CCHAIN', symbol: 'AVAX', address: null }],
      logo: 'https://api.rango.exchange/blockchains/avax_cchain.svg',
      displayName: 'Avalanche',
      shortName: 'Avax',
      sort: 6,
      color: '#e84142',
      enabled: true,
      type: 'EVM',
      chainId: '0xa86a',
      info: {
        chainName: 'Avalanche C-Chain',
        nativeCurrency: { name: 'AVAX', symbol: 'AVAX', decimals: 18 },
        rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
        blockExplorerUrls: ['https://snowtrace.io'],
        addressUrl: 'https://snowtrace.io/address/{wallet}',
        transactionUrl: 'https://snowtrace.io/tx/{txHash}',
        tokenUrl: 'https://snowtrace.dev/token/{address}',
      },
    },
    {
      name: 'ARBITRUM',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'ARBITRUM', symbol: 'ETH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/arbitrum.svg',
      displayName: 'Arbitrum',
      shortName: 'Arbitrum',
      sort: 7,
      color: '#28a0f0',
      enabled: true,
      type: 'EVM',
      chainId: '0xa4b1',
      info: {
        chainName: 'Arbitrum One',
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://arb1.arbitrum.io/rpc'],
        blockExplorerUrls: ['https://arbiscan.io'],
        addressUrl: 'https://arbiscan.io/address/{wallet}',
        transactionUrl: 'https://arbiscan.io/tx/{txHash}',
        tokenUrl: 'https://arbiscan.io/token/{address}',
      },
    },
    {
      name: 'FANTOM',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'FANTOM', symbol: 'FTM', address: null }],
      logo: 'https://api.rango.exchange/blockchains/fantom.png',
      displayName: 'Fantom',
      shortName: 'Fantom',
      sort: 9,
      color: '#337afe',
      enabled: true,
      type: 'EVM',
      chainId: '0xfa',
      info: {
        chainName: 'Fantom Opera',
        nativeCurrency: { name: 'FTM', symbol: 'FTM', decimals: 18 },
        rpcUrls: ['https://rpc.ftm.tools'],
        blockExplorerUrls: ['https://ftmscan.com'],
        addressUrl: 'https://ftmscan.com/address/{wallet}',
        transactionUrl: 'https://ftmscan.com/tx/{txHash}',
        tokenUrl: 'https://explorer.fantom.network/token/{address}',
      },
    },
    {
      name: 'OPTIMISM',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'OPTIMISM', symbol: 'ETH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/optimism.svg',
      displayName: 'Optimism',
      shortName: 'Optimism',
      sort: 10,
      color: '#FF0420',
      enabled: true,
      type: 'EVM',
      chainId: '0xa',
      info: {
        chainName: 'Optimism',
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://mainnet.optimism.io'],
        blockExplorerUrls: ['https://optimistic.etherscan.io'],
        addressUrl: 'https://optimistic.etherscan.io/address/{wallet}',
        transactionUrl: 'https://optimistic.etherscan.io/tx/{txHash}',
        tokenUrl: 'https://optimistic.etherscan.io/token/{address}',
      },
    },
    {
      name: 'OKC',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'OKC', symbol: 'OKT', address: null }],
      logo: 'https://api.rango.exchange/blockchains/okx.png',
      displayName: 'OKX Chain (OKC)',
      shortName: 'Okx',
      sort: 11,
      color: '#29a0f0',
      enabled: true,
      type: 'EVM',
      chainId: '0x42',
      info: {
        chainName: 'OKX Chain',
        nativeCurrency: { name: 'OKT', symbol: 'OKT', decimals: 18 },
        rpcUrls: ['https://exchainrpc.okex.org'],
        blockExplorerUrls: ['https://www.oklink.com/en/okc'],
        addressUrl: 'https://www.oklink.com/en/okc/address/{wallet}',
        transactionUrl: 'https://www.oklink.com/en/okc/tx/{txHash}',
        tokenUrl: null,
      },
    },
    {
      name: 'CRONOS',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'CRONOS', symbol: 'CRO', address: null }],
      logo: 'https://api.rango.exchange/blockchains/cronos.svg',
      displayName: 'Cronos',
      shortName: 'Cronos',
      sort: 12,
      color: '#1a90ff',
      enabled: true,
      type: 'EVM',
      chainId: '0x19',
      info: {
        chainName: 'Cronos Mainnet Beta',
        nativeCurrency: { name: 'CRO', symbol: 'CRO', decimals: 18 },
        rpcUrls: ['https://cronosrpc-1.xstaking.sg'],
        blockExplorerUrls: ['https://cronoscan.com'],
        addressUrl: 'https://cronoscan.com/address/{wallet}',
        transactionUrl: 'https://cronoscan.com/tx/{txHash}',
        tokenUrl: 'https://cronoscan.com/token/{address}',
      },
    },
    {
      name: 'MOONRIVER',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'MOONRIVER', symbol: 'MOVR', address: null }],
      logo: 'https://api.rango.exchange/blockchains/moonriver.svg',
      displayName: 'MoonRiver',
      shortName: 'MoonRiver',
      sort: 13,
      color: '#F3B404',
      enabled: true,
      type: 'EVM',
      chainId: '0x505',
      info: {
        chainName: 'MoonRiver',
        nativeCurrency: { name: 'MOVR', symbol: 'MOVR', decimals: 18 },
        rpcUrls: ['https://rpc.moonriver.moonbeam.network'],
        blockExplorerUrls: ['https://moonriver.moonscan.io'],
        addressUrl: 'https://moonriver.moonscan.io/address/{wallet}',
        transactionUrl: 'https://moonriver.moonscan.io/tx/{txHash}',
        tokenUrl: null,
      },
    },
    {
      name: 'MOONBEAM',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'MOONBEAM', symbol: 'GLMR', address: null }],
      logo: 'https://api.rango.exchange/blockchains/moonbeam.png',
      displayName: 'MoonBeam',
      shortName: 'MoonBeam',
      sort: 14,
      color: '#B3206B',
      enabled: true,
      type: 'EVM',
      chainId: '0x504',
      info: {
        chainName: 'MoonBeam',
        nativeCurrency: { name: 'GLMR', symbol: 'GLMR', decimals: 18 },
        rpcUrls: ['https://rpc.api.moonbeam.network'],
        blockExplorerUrls: ['https://moonbeam.moonscan.io'],
        addressUrl: 'https://moonbeam.moonscan.io/address/{wallet}',
        transactionUrl: 'https://moonbeam.moonscan.io/tx/{txHash}',
        tokenUrl: null,
      },
    },
    {
      name: 'HECO',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'HECO', symbol: 'HT', address: null }],
      logo: 'https://api.rango.exchange/blockchains/heco.png',
      displayName: 'Heco',
      shortName: 'Heco',
      sort: 15,
      color: '#4CA852',
      enabled: true,
      type: 'EVM',
      chainId: '0x80',
      info: {
        chainName: 'Huobi ECO Chain Mainnet',
        nativeCurrency: { name: 'HT', symbol: 'HT', decimals: 18 },
        rpcUrls: ['https://http-mainnet.hecochain.com'],
        blockExplorerUrls: ['https://hecoinfo.com'],
        addressUrl: 'https://hecoinfo.com/address/{wallet}',
        transactionUrl: 'https://hecoinfo.com/tx/{txHash}',
        tokenUrl: null,
      },
    },
    {
      name: 'AURORA',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'AURORA', symbol: 'ETH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/aurora.svg',
      displayName: 'Aurora',
      shortName: 'Aurora',
      sort: 15,
      color: '#78d64b',
      enabled: true,
      type: 'EVM',
      chainId: '0x4e454152',
      info: {
        chainName: 'Aurora Mainnet',
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://mainnet.aurora.dev'],
        blockExplorerUrls: ['https://explorer.mainnet.aurora.dev'],
        addressUrl: 'https://explorer.mainnet.aurora.dev/address/{wallet}',
        transactionUrl: 'https://explorer.mainnet.aurora.dev/tx/{txHash}',
        tokenUrl: 'https://explorer.mainnet.aurora.dev/token/{address}',
      },
    },
    {
      name: 'HARMONY',
      defaultDecimals: 18,
      addressPatterns: ['^(one1)[0-9a-z]{38}$', '^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'HARMONY', symbol: 'ONE', address: null }],
      logo: 'https://api.rango.exchange/blockchains/harmony.svg',
      displayName: 'Harmony',
      shortName: 'Harmony',
      sort: 15,
      color: '#50AEE9',
      enabled: true,
      type: 'EVM',
      chainId: '0x63564c40',
      info: {
        chainName: 'Harmony Mainnet',
        nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
        rpcUrls: ['https://api.s0.t.hmny.io'],
        blockExplorerUrls: ['https://explorer.harmony.one'],
        addressUrl: 'https://explorer.harmony.one/address/{wallet}',
        transactionUrl: 'https://explorer.harmony.one/tx/{txHash}',
        tokenUrl: null,
      },
    },
    {
      name: 'EVMOS',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'EVMOS', symbol: 'EVMOS', address: null }],
      logo: 'https://api.rango.exchange/blockchains/evmos.png',
      displayName: 'Evmos',
      shortName: 'Evmos',
      sort: 15,
      color: '#2D2925',
      enabled: true,
      type: 'EVM',
      chainId: '0x2329',
      info: {
        chainName: 'Evmos',
        nativeCurrency: { name: 'EVMOS', symbol: 'EVMOS', decimals: 18 },
        rpcUrls: ['https://eth.bd.evmos.org:8545'],
        blockExplorerUrls: ['https://evm.evmos.org'],
        addressUrl: 'https://evm.evmos.org/address/{wallet}',
        transactionUrl: 'https://evm.evmos.org/tx/{txHash}',
        tokenUrl: null,
      },
    },
    {
      name: 'GNOSIS',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'GNOSIS', symbol: 'XDAI', address: null }],
      logo: 'https://api.rango.exchange/blockchains/gnosis.svg',
      displayName: 'Gnosis',
      shortName: 'Gnosis',
      sort: 26,
      color: '#3E6957',
      enabled: true,
      type: 'EVM',
      chainId: '0x64',
      info: {
        chainName: 'Gnosis Chain',
        nativeCurrency: { name: 'XDAI', symbol: 'XDAI', decimals: 18 },
        rpcUrls: ['https://rpc.gnosischain.com'],
        blockExplorerUrls: ['https://blockscout.com/xdai/mainnet'],
        addressUrl: 'https://blockscout.com/xdai/mainnet/address/{wallet}',
        transactionUrl: 'https://blockscout.com/xdai/mainnet/tx/{txHash}',
        tokenUrl: null,
      },
    },
    {
      name: 'FUSE',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'FUSE', symbol: 'FUSE', address: null }],
      logo: 'https://api.rango.exchange/blockchains/fuse.png',
      displayName: 'Fuse',
      shortName: 'Fuse',
      sort: 29,
      color: '#C5F9AD',
      enabled: true,
      type: 'EVM',
      chainId: '0x7a',
      info: {
        chainName: 'Fuse Mainnet',
        nativeCurrency: { name: 'FUSE', symbol: 'FUSE', decimals: 18 },
        rpcUrls: ['https://rpc.fuse.io'],
        blockExplorerUrls: ['https://explorer.fuse.io'],
        addressUrl: 'https://explorer.fuse.io/address/{wallet}',
        transactionUrl: 'https://explorer.fuse.io/tx/{txHash}',
        tokenUrl: null,
      },
    },
    {
      name: 'BOBA',
      defaultDecimals: 18,
      addressPatterns: ['^(0x)[0-9A-Fa-f]{40}$'],
      feeAssets: [{ blockchain: 'BOBA', symbol: 'ETH', address: null }],
      logo: 'https://api.rango.exchange/blockchains/boba.png',
      displayName: 'Boba',
      shortName: 'Boba',
      sort: 39,
      color: '#ccff00',
      enabled: true,
      type: 'EVM',
      chainId: '0x120',
      info: {
        chainName: 'Boba Network',
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://mainnet.boba.network'],
        blockExplorerUrls: ['https://bobascan.com/'],
        addressUrl: 'https://bobascan.com//address/{wallet}',
        transactionUrl: 'https://bobascan.com//tx/{txHash}',
        tokenUrl: null,
      },
    },
  ],
} as unknown as Meta;
